/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Link } from '@ta-interaktiv/contentbricks'
import { Icon, Button } from 'semantic-ui-react'
import { Element } from 'react-scroll'
import { TopMenu } from '../menu'
import { SegmentHeader } from '../segmentheader'
import { SectionOverview } from '../sectionoverview'
import { VideoPlayer } from '../videoplayer'
import { SideElement } from '../sideelement'

import menuData from '../../../data/menu.json'

const ARTICLE_ID = '183233115359'
const parseJsonData = json => {
  return json.data
}
const isMobile = window.innerWidth < 768

export class AppComponent extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      hasTooltipHint: false,
      menuOpen: false
    }
    this.menuRef = React.createRef()
    this.closeMenu = this.closeMenu.bind(this)
    this.openMenu = this.openMenu.bind(this)
  }

  openMenu() {
    this.setState({ menuOpen: true })
    this.menuRef.current.setMenuPosition()
    // Disable body scroll?? npm body-scroll-lock
  }

  closeMenu() {
    this.setState({ menuOpen: false })
    // Re-enable body scroll?? npm body-scroll-lock
  }

  componentDidMount() {
    // restore scroll position from previous visit?
    if (!window.location.hash) {
      if (localStorage.getItem('scrllPstn')) {
        const scrllPstn = parseFloat(localStorage.getItem('scrllPstn'))
        if (scrllPstn && scrllPstn > 650) {
          console.log('restore:', scrllPstn)
          document.documentElement.scrollTop = isMobile
            ? scrllPstn
            : scrllPstn - scrllPstn / 6 // scrllPstn/6 is just a weird correction, don't know why this is necessary...
        }
      }
    }
    window.addEventListener(
      'scroll',
      function() {
        if (timer !== null) {
          clearTimeout(timer)
        }
        const timer = setTimeout(function() {
          const scrllPstn = document.documentElement.scrollTop
          localStorage.setItem('scrllPstn', scrllPstn.toString())
        }, 150)
      },
      false
    )
  }

  componentWillUnmount() {
    // console.log('componentWillUnmount')
    window.removeEventListener('scroll')
  }

  render() {
    return (
      <div className='index'>
        <Masthead articleId={ARTICLE_ID} />
        <ThemeSwitch />

        <header className='ui vertical  very fitted titleImage  segment'>
          <div className='ui container'>
            <div className='ui header'>
              <h1>Qui je suis vraiment</h1>
              <h2>
                La véritable histoire de Martina Hingis, la meilleure sportive que
                la Suisse ait jamais connue
              </h2>
            </div>
          </div>
        </header>
        <div className='content'>
          <div className='ui container'>
            <figcaption>Photo: Cyrill Matter</figcaption>
          </div>
        </div>

        <div className='ui vertical segment'>
          <div className='ui text container'>
            <div className='ta metainfo'>
              <div className='ta author'>
                Christof Gertsch et Mikael Krogerus, Jean-Claude Schertenleib
                pour l'adaptation française
              </div>
              <div className='ta updated'>Mis à jour le 29 octobre 2021</div>
            </div>
          </div>
        </div>

        <div className='content' onClick={isMobile ? this.closeMenu : null}>
          <Element className='section' name='section-1' id='section-1'>
            <div className='ui vertical segment' style={{ padding: '0' }}>
              <div className='ui text container'>
                <div className='ta text prologue'>
                  <h5>Prologue</h5>
                    <p>
                      Juin 2020, soit quelques jours après la fin du lockdown
                      décrété en raison de la pandémie de coronavirus. Nous
                      sommes assis dans le lobby du Grand Resort Bad Ragaz. En
                      face de nous, la plus grande sportive suisse de tous les
                      temps, celle qui, si longtemps, ne voulait rien avoir à
                      faire avec les médias. Elle nous regarde, nous questionne.
                    </p>
                    <p>
                      Il n’a pas été facile d’entrer en contact avec Martina
                      Hingis. Après de nombreux refus au fil des ans, elle avait
                      enfin accepté de nous parler. Cette première rencontre fut
                      suivie par beaucoup d’autres, durant lesquelles elle nous
                      a raconté sa vie. Pendant près d’une année, nous nous
                      sommes souvent retrouvés et là, soudainement, la question
                      tombe:
                    </p>
                    <p>
                      «En fait, pourquoi avez-vous voulu passer autant de temps
                      avec moi?»
                    </p>
                    <p>
                      «Pourquoi avez-vous accepté de participer?» lui avons-nous
                      répondu.
                    </p>
                    <p>
                      «Parce que j’ai remarqué que, peut-être une fois, je
                      pourrais expliquer ma version des choses. Me montrer telle
                      que je le suis réellement. Je me suis dit: la chance se
                      présente et j’espère qu’il en sera ainsi.»
                    </p>
                    <p>
                      Elle qui habituellement parle sans points ni virgule, qui
                      plaisante et rigole en permanence, s’offre une plus longue
                      pause.
                    </p>
                    <p>
                      «J’aimerais juste que l’on montre enfin mon vrai visage.
                      Pas la chipie arrogante qui refusait de donner des
                      interviews. Non, je veux expliquer la Martina que je suis
                      réellement.»
                    </p>
                    <p>
                      S'en est suivi ce qu'elle nous a répété depuis lors,
                      jusqu'à la dernière rencontre peu avant la parution de ce
                      texte: «Mon histoire n'est pas une histoire de victime,
                      c'est l’histoire d’une réussite.»
                    </p>
                </div>
              </div>
            </div>
          </Element>

          <div className='ui text container'>
            <SectionOverview
              menuData={parseJsonData(menuData)}
              closeMenu={this.closeMenu}
            />
          </div>
        </div>

        <div className='sticky-wrapper'>
          <div className='menu-toggle'>
            <div className='button-wrapper'>
              <Button onClick={this.openMenu}>
                <Icon name='bars' />
              </Button>
            </div>
          </div>

          <div className='content' onClick={isMobile ? this.closeMenu : null}>
            <Element className='section' name='section-2' id='section-2'>
              <div className='ui vertical segment'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h5>La genèse de l’histoire</h5>
                    <p>
                      La joueuse de tennis Martina Hingis est l’une de ces
                      personnalités dont on croit tout connaître. Même celui qui
                      ne différencie pas le tennis du squash sait que, dans les
                      années 1990, une adolescente suisse évoluait au sommet de
                      la hiérarchie mondiale, qu’elle était devenue la plus
                      jeune numéro 1 de l’histoire. Que, techniquement,
                      tactiquement, elle était exceptionnelle – peut-être le
                      plus grand talent de tous les temps –, elle répondait avec
                      finesse et plaisir de jouer aux «machines» qu’étaient déjà
                      Steffi Graf et Monica Seles.
                    </p>
                    <p>
                      On sait aussi qu’elle a remporté quelques titres de Grand
                      Chelem, qu’elle a mené le classement mondial pendant des
                      années. Mais dans la mémoire populaire, on se rappelle
                      surtout d’une affaire de cocaïne. Qu’elle s’était retirée
                      du tennis, avant de revenir. Qu’elle avait une maman
                      sévère, qui l’entraînait, la surveillait et qui, en 1997,
                      disait: «Avec Patty (Schnyder), tout est toujours positif;
                      pas avec nous, Martina est toujours l’étrangère.»
                    </p>
                    <p>Avec ces quelques mots, tout était dit.</p>
                    <SideElement side='left'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/2-0-wimbledon-1996.jpg'
                          : '../../images/2-0-wimbledon-1996-desktop.jpg')}
                      />
                      <figcaption>
                        Célébrée dans le monde entier – mais jamais vraiment en
                        Suisse: Martina Hingis à Wimbledon en 1996. Photo: Laci
                        Perenyi (Imago)
                      </figcaption>
                    </SideElement>
                    <p>
                      Néanmoins, un sentiment perdurait: celui qu’en réalité,
                      absolument rien n’a été dit. En comptant rapidement, on
                      dénombre une douzaine de biographies de Roger Federer.
                      Aucune de Martina Hingis. Même pas un portrait complet. En
                      2017, après sa retraite, quelques interviews, dans
                      lesquelles nous n’apprenions souvent rien, ont certes
                      paru. Puis, soudainement, le silence. Elle s’était
                      retirée, non pas déçue de la Suisse, mais bien des
                      retombées médiatiques qui étaient toujours négatives la
                      concernant.
                    </p>
                    <p>
                      Pendant plus de deux ans, nous nous sommes rapprochés de
                      Martina Hingis. Nous avons effectué des recherches, lu
                      tout ce que l’on trouvait à son sujet. Nous avons parlé
                      avec des compagnes de route et des adversaires, de la
                      Floride à Taïwan. Et, surtout, nous nous sommes entretenus
                      directement avec elle, puis finalement avec sa maman,
                      Melanie Molitor. Nous nous retrouvions dans des salles de
                      tennis, au restaurant, en promenade, chez elle à la
                      maison, dans son écurie, où elle nous montrait ses
                      chevaux.
                    </p>
                    <p>
                      Il existe un seul et unique – d’ailleurs excellent – livre
                      consacré à Hingis. Celui de l’écrivain romand Étienne
                      Barilier qui, habituellement, écrit plutôt sur Bach et
                      Giacometti. Il y parle du jeu de la jeune Hingis de
                      manière littéraire, avec les yeux de l’admirateur.
                    </p>
                    <p>
                      Le livre de Barilier est épuisé, mais l’exemplaire que
                      nous avons pu trouver a été pour nous une aide et une
                      inspiration. Barilier avait terminé son travail fin 1996,
                      donc avant l’avènement de Martina Hingis, ce qui rend sa
                      lecture, vingt-cinq ans après, encore plus intéressante.
                    </p>
                    <p>
                      Notre histoire commence sur un court de tennis à Roznov,
                      dans l’ancienne Tchécoslovaquie, là ou Martina Hingis, à
                      l’âge de trois ans, a tenu une raquette de tennis pour la
                      première fois de sa vie. Elle était une enfant prodige,
                      elle allait devenir une légende de son sport, célébrée
                      avec force dans le monde entier, sauf en Suisse.
                    </p>
                    <p>
                      Au contraire de Roger Federer, il semble que Martina
                      Hingis ne s’est jamais totalement installée dans le cœur
                      des Suissesses et des Suisses. Un sentiment diffus
                      difficile à décrire, mais tenace: bien que superstar
                      internationale, Martina Hingis n’a jamais eu d’important
                      sponsor helvétique. Au moment de sa retraite, la «NZZ» la
                      surnommait encore: «La non-accomplie». Le diagnostic à
                      distance du psychologue Allan Guggenbühl parlait d’une
                      relation «malsaine» entre une mère et sa fille. Le
                      magazine «Schweizer Familie» posait à des personnalités la
                      même question: «Martina Hingis gagne-t-elle trop
                      d’argent?» Quant à Margrit Sprecher, l’une des
                      journalistes les plus renommées du pays, elle chuchotait
                      avec plaisir que la maman avait choisi le père biologique
                      pour les meilleurs gènes et le beau-père pour les papiers
                      idéaux.
                    </p>
                    <p>
                      En 1997, quand le magazine «Facts» désigne, après un
                      sondage représentatif, la «plus grande sportive suisse de
                      tous les temps», un tiers des sondés désignent Hingis en
                      numéro 1. Mais au classement de la popularité, le résultat
                      est bien différent. La victoire revient à la coureuse à
                      pied Franziska Rochat-Moser, devant le skieur Michael von
                      Grünigen et une autre spécialiste de la course, Anita
                      Weyermann. Martina Hingis? On ne la retrouve qu’au
                      douzième rang.
                    </p>
                    <p>
                      La même année, l’émission «10 vor 10» découvre un apprenti
                      agriculteur qui avait fréquenté les bancs d’école en même
                      temps qu’Hingis. Première question au jeune homme:
                      «Combien gagnes-tu?» Réponse: «1300 francs bruts.»
                    </p>
                    <p>
                      Les journalistes ont leur «story», Martina vs Martin, elle
                      si riche, lui si pauvre; elle, dans un autre monde, lui,
                      ancré dans la terre. Et après une victoire au tournoi de
                      Tokyo, un reporter du «Tagesschau» (le téléjournal
                      alémanique) lui a demandé à l’aéroport: «Est-ce que l’on
                      arrive à garder les pieds sur terre?» Et: «Que fait-on
                      avec autant d’argent?»
                    </p>
                    <p>
                      Martina Hingis ne correspondait tout simplement pas à
                      l’image que l’on se fait, en Suisse, de la femme, et
                      spécialement celle d’une émigrante: elle était trop
                      rebelle, elle avait trop confiance en elle. Et elle
                      connaissait trop de succès.
                    </p>
                    <SideElement side='right'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/2-1-letterman_1997.jpg'
                          : '../../images/2-1-letterman_1997.jpg')}
                      />
                      <figcaption>
                        À la table la plus importante des États-Unis: Martina
                        Hingis est l'invitée du late night show de David
                        Letterman en novembre 1997. Photo: Keystone/AP Photo/CBS
                      </figcaption>
                    </SideElement>
                    <p>
                      «Je n’ai jamais compris l’image que l’on se faisait de
                      moi», nous a-t-elle un jour confié. «Je n’ai jamais eu de
                      problèmes avec la Suisse. Et je ne crois pas non plus que
                      les Suisses en avaient avec moi. Au contraire. Lorsque
                      aujourd’hui, je rencontre des gens dans le bus qui me
                      disent «à cause de vous, nous devions nous réveiller au
                      milieu de la nuit pour vous voir jouer et cela nous
                      procurait un immense plaisir», je me dis: c’est bien, je
                      suis ici à la maison. C’est ici que je suis heureuse.»
                    </p>
                    <p>
                      Cela semble difficile à croire aujourd’hui, mais en 1994,
                      quand Hingis a rejoint le circuit professionnel, il n’y
                      avait pas la moindre Suissesse (et pas le moindre Suisse)
                      connus mondialement. C’était une époque où la Suisse était
                      focalisée sur elle-même – le non à l’Espace économique
                      européen et la progression de l’UDC, devenu le parti
                      politique le plus puissant du pays, ont marqué les années
                      nonante. À cette époque, la seule Suissesse connue à
                      l’étranger était Heidi, le personnage de livres pour
                      enfants; Pirmin Zurbriggen, Vreni Schneider et Stéphane
                      Chapuisat étaient plus des célébrités régionales que des
                      stars internationales. C’est dans cette période-là que
                      commence l’ascension de Martina Hingis.
                    </p>
                    <p>
                      Son succès international lui a valu des résistances, alors
                      que, pour d'autres, elle était une pionnière
                    </p>
                    <p>
                      Particulièrement pour un certain Roger Federer. Le Suisse
                      moyen se délecte de l’impressionnante durée de sa
                      carrière, il est fier de compter dans ses rangs un tel
                      joueur de tennis. Peu importe qu’il soit très riche, peu
                      importe que l’on ne le voit que peu au pays, aucune
                      allusion non plus au fait que sa mère soit sud-africaine.
                    </p>
                    <p>
                      Nous lui avons demandé s’il partageait cette analyse. Et
                      il nous a écrit: «Martina a réellement été très importante
                      pour moi, parce qu’avant elle, jamais encore un Suisse
                      n’avait dominé de telle façon un sport mondial. Elle était
                      une inspiration, un incroyable exemple. Elle m’a motivé,
                      en montrant ce qui était possible. C’est absolument
                      incroyable ce qu’elle est parvenue à atteindre à un si
                      jeune âge.»
                    </p>
                    <p>
                      Martina Hingis fut la première Suissesse que l’on ne
                      connaissait pas seulement dans toute l’Europe, mais aussi
                      en Asie, en Amérique du Sud, aux États-Unis. Martina
                      Hingis, invitée décontractée de David Letterman, le maître
                      des talk-show télévisés; Martina Hingis, présente dans des
                      shows au Japon. Martina Hingis, qui gagnait des millions,
                      qui voyageait autour du monde en jet. En quelques mots: la
                      première superstar helvétique était une adolescente, une
                      femme, une émigrante.
                    </p>
                    <div style={{ marginTop: '2em' }}>
                      <VideoPlayer
                        mp4={require('../../videos/01-japan-gameshow-fr.mp4')}
                        posterImage={require('../../videos/01-japan-gameshow.jpg')}
                        caption='Tous contre un: émission de télévision japonaise 2012. Source: <a href="https://www.youtube.com/watch?v=0KlKBSOGwWE&t=230s">Taiku-Kay TV/Youtube</a>'
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Element>

            <div className='ui vertical segment' style={{ padding: '0' }}>
              <Element className='section' name='section-3' id='section-3'>
                <SegmentHeader
                  part='Première partie'
                  title='L’enfance en Tchécoslovaquie'
                  image={require(isMobile
                    ? '../../images/3-privat.jpg'
                    : '../../images/3-privat-desktop.jpg')}
                  caption='Photo: Privé'
                />
              </Element>

              <Element className='section' name='section-3-1' id='section-3-1'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Chapitre 1</h6>
                    <h5>Quand la maman rêvait de liberté</h5>
                    <p>
                      Melanie Melitor a vu le jour en 1957 à Roznov, une petite
                      ville de Moravie dans la partie tchèque de l’ancienne
                      Tchécoslovaquie. Sa maman était institutrice, son papa
                      paysagiste. Il venait de la région roumaine de la Valachie
                      et fut, pour Melanie Molitor, une figure marquante.
                      Pendant la Seconde Guerre mondiale, il s’est battu contre
                      l’occupant allemand; puis, il s’est opposé au régime
                      communiste et a été envoyé pour huit ans dans un camp de
                      travail, une mine d’uranium.
                    </p>
                    <SideElement side='left'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/3-1-privat.jpg'
                          : '../../images/3-1-privat.jpg')}
                      />
                      <figcaption>
                        Le dissident et ses descendants: Martina Hingis sur les
                        genoux de son grand-père. Photo: Privé
                      </figcaption>
                    </SideElement>
                    <p>
                      «Les communistes voulaient le casser», explique Melanie
                      Molitor. «Ils ne sont pas parvenus à leurs fins, mais ils
                      ont fait beaucoup de mal, à lui et à notre famille.» Elle
                      admirait sa solidité et sa patience, lui était gré de la
                      confiance qu’il plaçait en elle.
                    </p>
                    <p>
                      Dès l’enfance, elle a compris qu’être fille de dissident
                      allait être chose compliquée. Plus tard, elle a réalisé
                      qu’elle devait partir si elle voulait être libre. Et sa
                      chance, elle la trouva dans le sport. Elle pensait alors
                      que dans ce domaine, personne ne lui demanderait quelles
                      étaient les opinions politiques de son père.
                    </p>
                    <p>
                      «Selon la vision helvétique, ce que nous avions autour de
                      Roznov n’étaient que de petites collines», nous dit-elle.
                      «Pour moi, c’étaient des montagnes. Et je voulais devenir
                      sportive pour passer au-delà de ces montagnes.»
                    </p>
                    <p>
                      Pour Molitor, les montagnes étaient une métaphore pour
                      évoquer le rideau de fer.
                    </p>
                    <SideElement side='right'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/3-2-melanie-molitor.jpg'
                          : '../../images/3-2-melanie-molitor.jpg')}
                      />
                      <figcaption>
                        Martina Hingis a gagné contre sa mère pour la première
                        fois lorsqu'elle avait 10 ans. Photo: Art Seitz
                        (Gamma-Rapho/Getty Images)
                      </figcaption>
                    </SideElement>
                    <p>
                      Elle est arrivée au tennis par son frère aîné. Pour sa
                      maman, le plus important, c’était l’école; dès lors, elle
                      n’avait le droit de s’entraîner que lorsque ses notes
                      étaient bonnes. Comme il n’y avait pas de salles à Roznov,
                      l’hiver venu, elle s’entraînait au ski de fond, avec une
                      telle volonté qu’elle se retrouva aux portes de l’équipe
                      nationale. Mais ce qu’elle aimait le plus, c’était le
                      tennis.
                    </p>
                    <p>
                      À l’âge de 20 ans, Molitor s’est installée à Kosice, une
                      ville de la partie slovaque du pays. Elle y avait accepté
                      l’offre du club local pour le représenter dans le
                      championnat par équipes. Cette décision s’avéra bientôt
                      être une erreur, mais seulement sur le plan sportif. Elle
                      était insatisfaite par les possibilités d’entraînement et
                      le niveau de la ligue supérieure était alors trop élevé
                      pour elle. Mais c’est aussi là qu’elle rencontra Karol
                      Hingis, un joueur de tennis du VSZ Kosice, et qu’elle mit
                      au monde une fille, le 30 septembre 1980, trois ans après
                      son arrivée à Kosice.
                    </p>
                    <p>
                      Les parents lui donnèrent pour prénom le même que celui de
                      la meilleure joueuse de tennis au monde d’alors, Martina
                      Navrátilová. Pas en raison de ses extraordinaires
                      résultats sportifs, comme on le répétera souvent plus
                      tard, mais bien parce que, cinq ans auparavant,
                      Navrátilová avait laissé derrière elle la Tchécoslovaquie
                      et avait demandé l’asile politique aux États-Unis. Pour
                      Melanie Molitor, le nom Martina était le symbole de
                      l’espoir et de la liberté.
                    </p>
                    <p>
                      La jeune maman resta à Kosice durant trois ans, avant de
                      revenir avec sa fille à Roznov. Après avoir travaillé dans
                      une fabrique et appris le travail de jardinière d’enfants,
                      elle a repris, à dix minutes de sa maison, un café situé
                      dans un centre de tennis.
                    </p>
                  </div>
                </div>
              </Element>
              <Element className='section' name='section-3-2' id='section-3-2'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Chapitre 2</h6>
                    <h5>Comment le communisme a découvert le tennis</h5>
                    <p>
                      En 1948, le comité central du Parti communiste d’Union
                      soviétique lança un plan ambitieux: «Rattraper, puis
                      dépasser les pays capitalistes dans le domaine des records
                      sportifs.» On s’est mis à rechercher, dans les pays
                      communistes, les jeunes gens les plus prometteurs pour les
                      regrouper dans des internats où ils enduraient un
                      entraînement intense qui les menaient parfois à un
                      épuisement total. Le drill militaire était soutenu par les
                      sciences sportives les plus modernes et, comme on le sait
                      aujourd’hui, par un dopage systématique.
                    </p>
                    <p>
                      Ces mesures ont rapidement produit leurs effets. Ainsi,
                      lors des Jeux olympiques d’été 1952, à Helsinki, l’Union
                      soviétique s’est classée au deuxième rang du tableau des
                      médailles. Quatre ans plus tard, elle était déjà première,
                      aussi bien lors des Jeux d’hiver que ceux d’été.
                    </p>
                    <p>
                      Chaque pays communiste développa ses disciplines
                      préférées: en Hongrie, l’escrime, la lutte et la natation
                      étaient au sommet. En Roumanie, c’était la gymnastique. En
                      Tchécoslovaquie, on se concentra d’abord sur le hockey sur
                      glace, le football et la gymnastique. Le tennis était
                      considéré comme «un sport de loisirs et de plaisir
                      pratiqué par l’ennemi de classe». Lorsque, en 1954,
                      Jaroslav Drobný s’imposa à Wimbledon, la presse
                      tchécoslovaque n’en parla pas. Cinq ans auparavant, en
                      1949, il avait émigré en Angleterre.
                    </p>
                    <SideElement side='left'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/3-3-martina-navratilova.jpg'
                          : '../../images/3-3-martina-navratilova.jpg')}
                      />
                      <figcaption>
                        Martina Navrátilová: icône du service et du volley,
                        chercheuse de liberté, homonyme de Martina Hingis.
                        Photo: Leo Mason (PopperPhoto/Getty Images)
                      </figcaption>
                    </SideElement>
                    <p>
                      Les choses changèrent lorsque Vera Suková se retrouva en
                      finale à Wimbledon en 1962 et que Jan Kodes remporta le
                      tournoi britannique en 1973. Peu à peu, le Parti commença
                      à reconnaître la valeur des joueuses et joueurs de tennis
                      qui connaissaient le succès à l’Ouest. Et sous le slogan:
                      «Qui sera la nouvelle Suková, qui sera le nouveau Kodes?»,
                      les autorités essayèrent en 1975 – l’année où Martina
                      Navrátilová a fui aux États-Unis –, de détecter de
                      nouveaux talents.
                    </p>
                    <p>
                      Deux phénomènes furent ainsi découverts: Hana Mandlíková
                      et Ivan Lendl. Tous les deux optèrent plus tard pour une
                      autre nationalité, tout en continuant de célébrer leurs
                      succès pour la Tchécoslovaquie. C’était la fin du
                      scepticisme de la direction du Parti face à ce «sport de
                      capitalistes». Le tennis allait devenir l’une des
                      priorités des efforts sportifs nationaux.
                    </p>
                  </div>
                </div>
              </Element>
              <Element className='section' name='section-3-3' id='section-3-3'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Chapitre 3</h6>
                    <h5>Martina Hingis veut jouer, pas s’entraîner</h5>
                    <p>
                      En revenant à Roznov en 1983, Melanie Molitor était bien
                      devenue une excellente sportive, mais elle n’avait pas
                      pour autant réussi à franchir les montagnes. Encore moins
                      sortir de son pays.
                    </p>
                    <p>
                      Ce qui était un rêve – le sport devait lui apporter la
                      liberté – se transforma en plan: offrir cette possibilité
                      à sa propre fille. Martina Hingis devait devenir tellement
                      forte qu’elle pourrait échapper à l'exiguïté
                      tchécoslovaque.
                    </p>
                    <p>
                      Plus tard, en Suisse, cette volonté va fréquemment devenir
                      un terrain d’incompréhension. Beaucoup voyaient en Molitor
                      une impitoyable mamie du tennis, une sorte de Nick
                      Bollettieri au féminin, qui poussait à ce succès qu’elle
                      n’avait elle-même pas connu, qui volait l’enfance de sa
                      fille et qui voulait, à travers elle, gagner de l’argent.
                      Pourtant, de gloire et d’argent, il n’en a jamais été
                      question.
                    </p>
                    <p>
                      «Si je dis aujourd’hui qu’un rêve est devenu réalité, je
                      ne pense pas aux succès de Martina», nous dit-elle. «Je
                      pense que ses succès nous ont permis de visiter le monde.»
                    </p>
                    <p>
                      Et effectivement: lorsque, en 1993, Martina Hingis
                      remporte le tournoi junior de l’Open de France, à Paris, à
                      l’âge de 12 ans – aujourd’hui encore, elle reste la plus
                      jeune de l’histoire –, la maman insistait pour que, après
                      l’entraînement et entre les matches, toutes les deux
                      puissent visiter Notre-Dame, la Tour Eiffel ou le
                      Sacré-Cœur.
                    </p>
                    <p>
                      «Elle voulait que nous sortions pour voir d’autres choses,
                      pas toujours tennis, tennis, tennis», se rappelle Martina
                      Hingis. «Moi, cela m’énervait. Mais aujourd’hui je pense
                      que de nombreux autres enfants du tennis ont manqué
                      beaucoup de choses quand ils étaient juniors. Outre le
                      tennis, ma maman voulait aussi me montrer le monde.»
                    </p>
                    <p>
                      Le chemin de la réussite – Melanie Molitor l’a compris
                      rapidement – devait être différent de celui qu’elle avait
                      emprunté. Déjà durant sa propre carrière, elle tentait
                      d’analyser, de comprendre pourquoi elle n’y arrivait pas
                      en se comparant avec les Lendl, Mandlíková ou Navrátilová;
                      lui, elles, jouaient au tennis durant toute l’année, cinq
                      ou six heures chaque jour, alors qu’elle, l’hiver venu,
                      pratiquait le ski de fond. Voilà ce qui lui manquait:
                      chaque année, plusieurs mois d’entraînement. Elle avait
                      tapé énormément moins de balles que les autres. C’est ce
                      qui avait fait la différence.
                    </p>
                    <p>
                      À l’âge de 3 ans, Martina était déjà capable de réussir
                      jusqu’à quinze échanges avec sa maman. À 4 ans, la maman
                      augmenta le pensum d’entraînement à vingt minutes par
                      jour. À 5 ans, Martina passait quotidiennement quatre à
                      cinq heures sur le court.
                    </p>
                    <SideElement side='left'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/3-4-privat.jpg'
                          : '../../images/3-4-privat.jpg')}
                      />
                      <figcaption>
                        Certains enfants aiment les compétitions, Martina Hingis
                        ne les aime pas. Photo: Privé
                      </figcaption>
                    </SideElement>
                    <p>
                      Ce sont ses premiers souvenirs du terrain de tennis: «Nous
                      partions toujours en vélo et nous passions toute la
                      journée là-bas, chaque jour, vacances ou pas, jusqu’à ce
                      que j’entre à l’école à l’âge de 7 ans. Il y avait une
                      quarantaine, une cinquantaine d’enfants sur cinq courts de
                      sable, avec cinq parents complètement fous qui nous
                      entraînaient; parmi eux, maman. Les installations se
                      trouvaient dans un parc. Si les courts étaient occupés, on
                      jouait à autre chose, à cache-cache, au gendarme et au
                      voleur. J’aimais cela.»
                    </p>
                    <p>
                      Peut-être qu’à ce stade de l’histoire, il est nécessaire
                      (encore une fois) de faire une courte excursion dans la
                      réalité du communisme, afin de mieux comprendre ce qui se
                      passait alors à Roznov.
                    </p>
                    <p>
                      En Tchécoslovaquie, pratiquement tout le monde était
                      astreint au travail, les femmes également. Mais celui-ci
                      n'avait pas la même signification qu’à l’Ouest. Pour la
                      majorité, le travail ne permettait pas de briller,
                      puisque, hormis au sein du Parti, il n’y avait aucune
                      possibilité de progresser, aucune perspective de carrière.
                      Être performant au travail ne rapportait rien.
                    </p>
                    <p>
                      Celui qui avait la volonté de réussir sa vie plaçait son
                      énergie ailleurs, le sport par exemple. En Suisse, c’est
                      le contraire: ici, lorsque l’on parle de succès, on pense
                      généralement à la réussite professionnelle. Celui qui joue
                      au tennis le fait pour équilibrer sa vie par rapport à son
                      emploi, parce que c’est sain et que cela procure du
                      plaisir. Et celui qui s’engage très jeune dans le sport,
                      même s’il parvient à accéder à l’élite, n’aspire pas
                      obligatoirement à une vie meilleure grâce au sport. Il
                      espère souvent y développer d’autres facultés comme la
                      résistance, l’esprit d’équipe ou la discipline, autant
                      d’éléments qui sont également importants dans une vie
                      professionnelle.
                    </p>
                    <p>
                      Pour les parents qui se retrouvaient sur les terrains de
                      tennis de Roznov, cet engagement était une petite révolte
                      face au système. Et plusieurs d’entre eux avaient l’espoir
                      de pouvoir, un jour, quitter ledit système. À l’image de
                      Melanie Molitor.
                    </p>
                    <SideElement side='right'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/3-5-privat.jpg'
                          : '../../images/3-5-privat.jpg')}
                      />
                      <figcaption>
                        Quarante enfants et cinq parents fous de tennis: sur la
                        terre battue de l'école de Rožnov. Photo: Privé
                      </figcaption>
                    </SideElement>
                    <p>
                      Tous les parents passent par ce moment où ils
                      s’interrogent sur le caractère de leur propre enfant.
                      Jouer permet de découvrir les premiers indices. Certains
                      enfants aiment la compétition: «Qui arrivera le premier
                      jusqu’à cet arbre?» D’autres – comme Martina Hingis –
                      montraient beaucoup moins d’intérêt.
                    </p>
                    <p>
                      Sur le court, elle n’était pas une travailleuse acharnée,
                      nous raconte sa maman, mais bien une enfant joueuse. Elle
                      n’aimait pas les longues séances, elle ne voulait pas
                      courir derrière les balles, elle n’aimait pas les
                      exercices monotones. Martina Hingis n’avait pas le goût de
                      l’entraînement.
                    </p>
                    <p>
                      De tous les enfants des places de tennis de Roznov, elle
                      était la plus jeune et la plus petite. Mais elle était
                      aussi la meilleure. Pour pouvoir mesurer combien Martina
                      Hingis était déjà brillante à 6 ans, il suffit de
                      s’imaginer son fils ou son petit-fils du même âge face à
                      un garçon de 9 ans. Même s’il est vraiment bon, le gosse
                      de 6 ans n’a aucune chance face à son aîné. Dans tous les
                      domaines. Parce qu’il est plus faible, qu’il est plus
                      lent. Dans son corps et dans sa tête.
                    </p>
                    <p>
                      Martina Hingis était ainsi à 6 ans. Mais elle compensait
                      son infériorité avec quelque chose de très compliqué à
                      saisir. Assise à la table à manger de la maison de
                      Schindellegi, sur les hauts du lac de Zurich, sa maman a
                      une explication. Elle nous la livre dans un long
                      monologue, toujours plus intense:
                    </p>
                    <p>
                      «Le papa de Martina vient de la partie slave de la
                      Hongrie. Les joueurs de tennis slaves ont un incroyable
                      punch et sentent la balle. Les Hongrois, eux, sont plus
                      roublards. En revanche, ma famille a des origines
                      pastorales, des gens venus avec leurs troupeaux des
                      Balkans jusqu’en Valachie, en passant par les Carpates.
                      Nous sommes un peuple coriace. Notre grande force? Nos
                      capacités d’adaptation. Les Tchèques ont toujours
                      capitulé. Contre les Russes, les Polonais, les Allemands.
                      Trois cents ans sous la coupe des Habsbourg, puis une
                      courte période de liberté, avant les
                      nationaux-socialistes, puis les communistes. Je suis
                      toujours étonnée de constater que la langue tchèque a
                      survécu. C’est une des preuves de ces capacités
                      d’adaptation: on est dépassés, mais on vit encore, on
                      reste soi-même. Nous savons ce que cela signifie d’arriver
                      à quelque chose avec peu. Quand nous sommes bien préparés,
                      nous y parvenons. Parfois, je pense que nous, les Suisses,
                      sommes presque identiques, parce que nous avons dû
                      survivre dans les montagnes. J’admire ces gens qui se sont
                      construits sur ces terres stériles et qui y ont survécu.
                      Si l’on prend maintenant tous ces éléments, le punch du
                      tennis slave, la roublardise hongroise et l’art de la
                      survie des gens de Valachie, que l’on se prépare
                      méticuleusement à chaque situation afin de n’être jamais
                      surpris, ni par un hiver glacé, ni par un coup du sort, eh
                      bien oui, le total de l’addition, c’est l’excellence du
                      jeu démontrée très tôt par Martina.»
                    </p>
                    <p>
                      À ce moment du récit, elle nous toise. S’assure-t-elle que
                      nous avons bien suivi sa démonstration ethnologique?
                    </p>
                    <p>Melanie Molitor poursuit:</p>
                    <p>
                      «Je suis vraiment étonnée: que ce soit avant ou après
                      Martina, personne n’a joué aussi bien au tennis. Elle
                      n’était pas la plus forte, elle n’a pas gagné le plus
                      grand nombre de tournois du Grand Chelem, elle n’a pas été
                      classée numéro 1 le plus longtemps de l’histoire. Mais
                      elle pouvait jouer au tennis. Et pour moi, c’était fou,
                      c’était beau et important de voir que l’on peut jouer au
                      tennis. On m’a souvent demandé quelle a été la victoire
                      qui a signifié le plus pour moi. Je réponds toujours: son
                      premier tournoi d’enfants, lorsqu’on a vu pour la première
                      fois qu’elle jouait véritablement. C’était aussi important
                      que de gagner un grand tournoi. Quand elle remportait un
                      titre de Grand Chelem, mais qu’elle n’avait pas vraiment
                      joué, cela ne me plaisait pas.»
                    </p>
                    <p>
                      Et Martina jouait beaucoup. À l’âge de 6 ans, elle
                      s’appuyait déjà sur une expérience de quatre-vingt matches
                      en tournois, elle était la meilleure joueuse de tennis
                      tchécoslovaque chez les moins de 9 ans.
                    </p>
                    <p>
                      C’était en 1986, deux ans avant le déménagement en Suisse.
                      Elle ignorait que la confiance en ses propres capacités
                      qu’elle avait assimilée à Roznov, mais aussi la joie
                      enfantine qu’elle montrait sur les courts, allaient être
                      totalement incomprises dans sa nouvelle patrie. Une
                      incompréhension qui a marqué sa vie jusqu’à aujourd’hui.
                    </p>
                  </div>
                </div>
              </Element>
            </div>

            <div className='ui vertical segment' style={{ padding: '0' }}>
              <Element className='section' name='section-4' id='section-4'>
                <SegmentHeader
                  part='Deuxième partie'
                  title='Le prodige suisse'
                  image={require(isMobile
                    ? '../../images/4-paris.jpg'
                    : '../../images/4-paris-desktop.jpg')}
                  caption='Photo: PopperPhoto/Getty Images'
                />
              </Element>

              <Element className='section' name='section-4-1' id='section-4-1'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Chapitre 4</h6>
                    <h5>Trop forte pour ce pays</h5>
                    <p>
                      Le 4 septembre 1988 – les deux se rappellent de cette date
                      comme de leur anniversaire – Melanie Molitor et sa fille,
                      alors âgée de 8 ans, passaient la frontière et entraient
                      en Suisse. Pour la maman, c’était enfin le franchissement
                      de la montagne, dont elle rêvait depuis si longtemps.
                      C’était la liberté. De ce voyage en automobile, Martina
                      Hingis s’en rappelle avec d’autres sentiments: «Tout ce
                      qui était important pour moi, j’avais dû le laisser à
                      Roznov», dit-elle.
                    </p>
                    <p>
                      Elles étaient en chemin vers Grabs, dans le canton de
                      Saint-Gall, où habitait le nouveau mari de Molitor,
                      Andreas Zogg, un représentant en informatique. Ils
                      s’étaient rencontrés lors d’un voyage d’affaires. Il était
                      membre d’honneur d’un ski-club, parlait de ski comme il
                      parlait de tennis. C’était parfait, pensait-elle.
                    </p>
                    <p>
                      «Si j’avais su que le rideau de fer allait tomber en 1989,
                      nous n’aurions pas pris la fuite», avoue aujourd’hui
                      Melanie Molitor. «Mais voilà, nous étions là. Et quand
                      j’ai découvert que le sport suisse – hormis le ski – se
                      trouvait encore au Moyen-Âge, j’ai commencé à me battre.»
                    </p>
                    <SideElement side='right'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/4-1-privat.jpg'
                          : '../../images/4-1-privat.jpg')}
                      />
                      <figcaption>
                        Elle jouait contre des adolescents alors qu'elle était
                        encore enfant: en juillet 1990, en Suisse. Photo: Privé
                      </figcaption>
                    </SideElement>
                    <p>
                      Il y avait alors plus qu’assez de courts de tennis, mais
                      les joueurs et joueuses dont c’était le hobby ne voulaient
                      pas libérer leur place pour une gamine de 8 ans.
                    </p>
                    <p>Molitor: «Disons-le ainsi, je me suis organisée!»</p>
                    <p>
                      Sa fille, elle aussi, va s’organiser. «Les premières
                      nuits, je n’arrêtais pas de pleurer», confie-t-elle. «À
                      Roznov, j’avais des cousines, des amies, nous étions
                      ensemble toute la journée sur les courts. À Grabs, j’étais
                      seule et je redoutais plus que tout mon premier jour
                      d’école. Je ne parlais pas le moindre mot d’allemand. Ce
                      n’était pas une belle période, mais elle a eu du bon: elle
                      a renforcé, soudé les liens entre maman et moi.»
                    </p>
                    <p>
                      La direction de l’école voulait d’abord renvoyer Martina
                      dans la classe inférieure, mais maman a insisté: on devait
                      lui offrir une chance. Ainsi, après les vacances
                      d’automne, Martina Hingis entre en seconde classe. Et
                      comme beaucoup d’enfants immigrés, elle s’y adapte de
                      manière radicale.
                    </p>
                    <p>
                      En un temps record, elle apprend le suisse allemand. Après
                      trois mois, elle comprenait presque tout; après six, on ne
                      discernait plus le moindre accent étranger dans son
                      dialecte du Rhin.
                    </p>
                    <p>
                      «Après trois semaines déjà, j’obtenais mon premier 6 en
                      mathématique», raconte-t-elle. «Dès lors, je le savais:
                      j’étais arrivée, j’étais comme les autres.»
                    </p>
                    <p>
                      Pour la maman, les choses furent plus difficiles. Elle
                      parlait déjà allemand, mais un allemand avec un tel accent
                      qu’on reconnaissait en elle l’étrangère. Mais elle aussi
                      rappela ses dons d’adaptation propres à la part morave de
                      ses racines et, rapidement, elle changea le nom de sa
                      fille de Hingisová en Hingis. Cela faisait plus suisse.
                    </p>
                    <SideElement side='right'>
                      <VideoPlayer
                        mp4={require('../../videos/02-kindheit-tennis-fr.mp4')}
                        posterImage={require('../../videos/02-kindheit-tennis.jpg')}
                        caption="«Je ne me souviens pas avoir jamais fait la grasse matinée»: Martina Hingis à l'âge de 10 ans. Source: <a href='https://www.srf.ch/play/tv/glanz--gloria-clip/video/das-sportmagazin-time-out-berichtet-erstmals-ueber-das-jungtalent-martina-hingis-time-out-vom-12-11-1990?urn=urn:srf:video:b89070f5-6430-4ddc-af27-7b927ec19b4c'>SRF «Time Out»</a>"
                      />
                    </SideElement>
                    <p>
                      À cette époque, la jeune fille s’appuyait sur deux
                      piliers: sa maman et le tennis. Cependant, la Suisse
                      n’était pas préparée à découvrir un enfant prodige de 8
                      ans. Dans de nombreux tournois, il n’y avait pas de
                      catégorie pour elle. Elle jouait contre des adolescentes,
                      parfois même contre des femmes au foyer.
                    </p>
                    <p>
                      «Elles pensaient: «Ohhh, comme c’est mignon, une petite
                      fille» et elles voulaient me retourner la balle tout
                      doucement», se rappelle Hingis. «Mais rapidement, elles
                      ont remarqué qu’il ne fallait pas renvoyer la balle trop
                      mollement à la gamine.»
                    </p>
                    <SideElement side='left'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/4-2-privat.jpg'
                          : '../../images/4-2-privat.jpg')}
                      />
                      <figcaption>
                      Une grande capacité d’adaptation: ici, lors d'un Grand Prix OVO à Wangs, dans le canton de Saint-Gall. Photo: Privé
                      </figcaption>
                    </SideElement>
                    <p>
                      La mignonne demoiselle, avec son incroyable feeling avec
                      la balle et ses retours sans concessions, n’était pas
                      seulement une joueuse au talent naturel. Martina Hingis
                      s’entraînait. Elle s’entraînait beaucoup: «Je ne me
                      rappelle pas avoir ralenti», dit-elle. «Nous nous
                      entraînions tous les jours, tous les jours. Quand tu es
                      enfant, il t’arrive de penser: ah, dimanche matin, il y a
                      cette émission pour les gosses à la télévision, ne
                      pourrais-je pas...? Mais non, ce n’était pas pour moi.»
                    </p>
                    <p>
                      Melanie Molitor savait que le tennis était un sport
                      unilatéral, elle imagina donc des moments de dépaysement.
                      Elles allaient marcher, partaient à bicyclette; il y avait
                      aussi le skateboard sur le Rhin pendant l’été, du ski
                      l’hiver sur les pistes de Wildhaus. Lors de ces
                      excursions, la maman apprenait beaucoup sur les
                      différences entre la Tchécoslovaquie et la Suisse:
                      «Lorsque je voyais combien d’enfants formaient des queues
                      au départ des remonte-pentes suisses, je disais à mes amis
                      de Roznov: «Renoncez au ski, vous n’avez pas la moindre
                      chance.»
                    </p>
                    <p>
                      Pour les mêmes raisons, Martina Hingis avait très
                      rapidement pris conscience du niveau élevé de son jeu: «À
                      mon âge, j’étais nettement la meilleure joueuse de
                      Tchécoslovaquie. Et dans ce pays, il y avait quelques-unes
                      des meilleures joueuses du monde. Dès lors, il semblait
                      logique de m’imaginer un jour au sommet.» En Suisse, c’est
                      la même chose: personne ne dit d’un champion junior de ski
                      qui parle d’atteindre l’élite mondial qu’il est animé
                      d’une confiance en soi malsaine.
                    </p>
                    <p>
                      Lors de l’une de nos rencontres, nous avons lancé à
                      Martina: «C’est peut-être très hypothétique, mais
                      seriez-vous aussi devenue joueuse de tennis si vous étiez
                      née en Suisse?»
                    </p>
                    <p>
                      «Ce n’est pas du tout une question difficile», a-t-elle
                      répondu. «Il est clair que je ne serais pas devenue
                      joueuse de tennis. Peut-être skieuse. Ou alors banquière.
                      Pourquoi aurais-je dû devenir joueuse de tennis? Je crois
                      que le rêve de voir le monde, on peut l’accomplir plus
                      facilement en étant banquière.»
                    </p>
                    <p>
                      Sportivement, elle continue en Suisse ce qu’elle avait
                      commencé en Tchécoslovaquie: à 8 ans, elle battait les
                      filles de 12; à 10 ans, elle gagnait pour la première fois
                      face à sa maman. Toutes les deux jouaient pour le TC
                      Grabs, dans la plus petite des ligues. Déçues par le
                      niveau de leurs adversaires, elles se mesuraient en
                      regardant laquelle des deux gagnait le plus rapidement
                      contre celles-ci!
                    </p>
                    <p>
                      Puis, Martina Hingis eût l’âge de participer à ses
                      premiers tournois internationaux...
                    </p>
                  </div>
                </div>
              </Element>

              <Element className='section' name='section-4-2' id='section-4-2'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Chapitre 5</h6>
                    <h5>
                    Deux filles à la conquête de l’Europe
                    </h5>
                    <p>
                      Tarbes est une petite ville au pied des Pyrénées
                      françaises. Tarbes est aussi, pour les talents du tennis
                      européens, ce que représente Wimbledon pour les pros. Le
                      tournoi «Les Petits As» est considéré comme un passage
                      obligé sur le chemin de la gloire future. Celui – celle –
                      qui s’impose ici, sait qu’il est dans la bonne direction.
                    </p>
                    <p>
                      Michael Chang, Rafael Nadal, Andy Murray, Anna Kournikova,
                      Kim Clijsters, Justine Henin, Lindsay Davenport – ils
                      (elles) ont tous gagné, ou au moins atteint la finale de
                      ce tournoi. La première qui s’imposa les deux années où
                      elle était invitée? Martina Hingis.
                    </p>
                    <p>
                      Ces débuts d’Hingis, Joana Czapalla, plus âgée de trois
                      ans, en a été le témoin. À l’époque, sous son nom de jeune
                      fille, Manta, elle était l’un des plus sérieux espoirs du
                      tennis helvétique. Aujourd’hui, elle dirige un bar à
                      sandwiches, avec filiales à Winterthour et au
                      Glattzentrum. Après plusieurs tentatives infructueuses,
                      nous avons réussi à l’atteindre à son bureau.
                    </p>
                    <p>
                      «Nous voyagions toujours ensemble, moi avec mon papa,
                      Martina avec sa maman», raconte-t-elle. «La plupart du
                      temps, nous prenions le train, nous avions du pain, un peu
                      de fromage. On dormait dans des hôtels simples et cela n’a
                      jamais posé de problèmes: nous voulions juste jouer au
                      tennis. Dans mes souvenirs, Tarbes occupe une place
                      spéciale: il y avait tant de public, tout y était si
                      professionnel. Nous avions l’impression d’appartenir au
                      monde des grands.»
                    </p>
                    <p>
                      Mais gagner à Tarbes ne garantit en aucun cas de parvenir
                      au bout du chemin. Des joueuses dont on n’a plus jamais
                      entendu parler se sont imposées là-bas, comme Nicole
                      London, Stéphanie Mabry ou Heike Rusch.
                    </p>
                    <SideElement side='right'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/4-3-privat.jpg'
                          : '../../images/4-3-privat-desktop.jpg')}
                      />
                      <figcaption>
                        À 11 ans, Martina Hingis remporte un tournoi pour
                        jeunes de quatorze ans à Gênes - et reçoit une Vespa
                        comme prix. Également sur la photo: Son amie Joana
                        Manta. Photo: Privé
                      </figcaption>
                    </SideElement>
                    <p>
                      «Il était clair que Martina était nettement meilleure que
                      nous», se rappelle Joana Czapalla. «Elle était
                      exceptionnelle par son talent, mais beaucoup de travail se
                      cachait derrière son succès. Les gens voient toujours
                      l’enfant prodige, mais il n’y en a pas. Il n’y a pas
                      d’enfants prodige, il y a seulement des talents qui
                      travaillent très durement.»
                    </p>
                    <p>
                      En raison d’une blessure à un genou, Czapalla s’est
                      retirée en 1996, au moment où Hingis a remporté son
                      premier tournoi professionnel. Leurs chemins se
                      séparaient, mais Czapalla se sentait encore liée à
                      Martina, même à distance: «Ce que nous avions entre nous
                      était spécial», dit-elle. «C’était beau, parce que
                      normalement, tu n’as aucune copine dans le monde du tennis
                      professionnel.»
                    </p>
                    <p>
                      Pour Martina Hingis aussi, cela signifiait beaucoup
                      d’avoir trouvé en Suisse une joueuse qui vivait le tennis
                      avec autant de passion qu’elle. Elle parle d’ailleurs avec
                      plus d’émotion de cette époque avec Joana Czapalla que de
                      certaines victoires chez les professionnelles. Elle se
                      rappelle d’une période sans soucis, en sécurité. C’étaient
                      des années riches d’expériences. Deux jeunes filles
                      découvraient l’Europe. À Gênes, Martina remporta un
                      tournoi alors qu’elle avait 11 ans; habituellement, seules
                      des jeunes filles de 14 pouvaient espérer la victoire. Sa
                      prime? Une Vespa!
                    </p>
                    <p>
                      En 1992, lorsque Martina Hingis gagna pour la deuxième
                      fois le tournoi de Tarbes, le tennis était la discipline
                      sportive la plus lucrative pour les femmes. Une victoire à
                      l’US Open rapportait plus ou moins un demi-million de
                      francs. Au même moment, la skieuse suisse qui avait gagné
                      le plus d’argent en Coupe du monde était Vreni Schneider;
                      ses gains pour toute la saison se montaient à 79'000
                      francs. 1992, c’était l’année où Jennifer Capriati, à
                      l’âge de 16 ans, avait battu Steffi Graf aux Jeux
                      olympiques; l’année où une jeune femme de 18 ans, Monica
                      Seles, devenait numéro 1 mondiale.
                    </p>
                    <SideElement side='left'>
                      <VideoPlayer
                        mp4={require('../../videos/03-roland-garros-1993-fr.mp4')}
                        posterImage={require('../../videos/03-roland-garros-1993.jpg')}
                        caption="La plus jeune gagnante de l'histoire: au tournoi junior féminin de Roland-Garros en 1993. Source: <a href='https://www.srf.ch/play/tv/glanz--gloria-clip/video/mit-martina-hingis-am-french-open-final-der-danen-juniorinnen-time-out-vom-7-6-1993?urn=urn:srf:video:a1fa6056-5c56-4659-9430-bc262eaa8887'>SRF «Time Out»</a>"
                      />
                    </SideElement>
                    <p>
                      Les sociétés de sponsoring et les agences de marketing
                      étaient toutes à la recherche du prochain «enfant
                      prodige». IMG, l’un des plus importants spécialistes de
                      marketing sportif au monde, avait contacté une première
                      fois Melanie Molitor en 1990, afin de prendre sa fille
                      sous contrat. Martina avait alors 10 ans. Melanie Molitor
                      avait refusé.
                    </p>
                    <p>
                      Pour cette dernière, tout était nouveau. Elle apprenait en
                      permanence, mais conservait aussi la retenue que le
                      communisme lui avait enseignée: toujours rester méfiante.
                      Mieux dire trois fois non, qu’une fois oui de trop.
                    </p>
                    <p>
                      C’est ainsi que les avances d’IMG, durant deux ans, ont
                      été ignorées. Tout comme, alors qu’elles habitaient encore
                      en Tchécoslovaquie, l’offre d’un fabricant de raquettes
                      avait été refusée. Molitor pensait qu’un tel contrat
                      exercerait une trop forte pression sur sa fille. Que se
                      passerait-il si sa carrière ne se déroulait pas comme
                      espéré? Devrait-elle rendre l’argent?
                    </p>
                    <p>
                      La Fédération suisse de tennis a également offert son
                      aide, des personnes privées cherchaient à investir de
                      l’argent. Mais souvent, ces propositions étaient assorties
                      d’une condition: que la maman cesse d’entraîner sa fille.
                      On ne lui faisait pas confiance, on ne la croyait pas
                      capable de transformer Martina en une grande championne.
                    </p>
                    <p>
                      N’est-ce pas là l’exemple parfait de la méfiance
                      qu’éprouvent les Suisses face aux étrangers?
                    </p>
                  </div>
                </div>
              </Element>

              <Element className='section' name='section-4-3' id='section-4-3'>
                <div className='ta text'>
                  <div className='ui text container'>
                    <h6>Chapitre 6</h6>
                    <h5>Pourquoi, en Suisse, les femmes qui réussissent dérangent</h5>
                    <p>
                      Damir Skenderovic est professeur d’histoire contemporaine
                      à l’Université de Fribourg. Sa spécialité: la recherche
                      sur les migrations. Nous lui avons demandé pourquoi, à son
                      avis, la Suisse n’a jamais montré beaucoup de chaleur
                      envers Martina Hingis et Melanie Molitor.
                    </p>
                    <p>
                      «Je crois qu’il faut prendre un peu de recul», répond
                      immédiatement Skenderovic.
                    </p>
                    <p>
                      «Entre 1945 et 1989, les gens venus d’Europe de l’Est
                      étaient les bienvenus en Suisse. Ils sont arrivés en trois
                      vagues: les Hongrois en 1956, les Tchécoslovaques en 1968,
                      les Polonais et les Yougoslaves dans les années 1980.
                      Certains d’entre eux étaient des réfugiés politiques, des
                      gens formés, des travailleurs de la construction, des
                      employés d’hôpitaux. Ils étaient efficaces, parlaient
                      rapidement l’allemand. Ils étaient discrets, on appréciait
                      volontiers ces étrangères et étrangers. À cette époque, on
                      ne cherchait pas à savoir si ces gens avaient fui leur
                      pays pour des questions politiques ou des raisons
                      économiques. Cela va changer avec la chute du rideau de
                      fer. Dès lors, les personnes qui arrivaient ne fuyaient
                      plus un régime totalitaire. Elles venaient chercher en
                      Suisse de meilleures conditions de vie. Et ces gens-là, on
                      les croisait avec plus de scepticisme.»
                    </p>
                    <SideElement side='right'>
                      <div className='quote-element'>
                        <p className='quote'>
                          «Dans le cas Hingis, on se trouve en présence de trois aspects discriminatoires: l’origine, le genre, les capacités.»
                          <div className='person'>Damir Skenderovic</div>
                        </p>
                      </div>
                    </SideElement>
                    <p>
                      Hingis et Molitor sont arrivées dans une phase
                      intermédiaire, juste une année avant l’effondrement du
                      bloc de l’Est. En raison du talent de la fille, elles
                      auraient donc dû être des immigrantes de l’élite, que l’on
                      acceptait volontiers. Pourquoi alors ont-elles été perçues
                      comme des étrangères, avec distance?
                    </p>
                    <p>
                      «En sciences sociales, explique Damir Skenderovic, on
                      parle «d’intersectionnalité» lorsque plusieurs aspects
                      différents de discrimination se chevauchent. Chacun de ces
                      aspects a ses propres conséquences, mais les interactions
                      entre celles-ci les renforcent encore et elles peuvent se
                      transformer en une lourde charge. Selon moi, dans le cas
                      Hingis, on se trouve en présence de trois aspects
                      discriminatoires: l’origine, le genre, les capacités.»
                    </p>
                    <div className='quote-element'>
                      <p className='quote'>
                        «Quand des hommes se défendent, c’est une preuve de force; lorsqu’une femme le fait, c’est une chipie.»
                        <div className='person'>Damir Skenderovic</div>
                      </p>
                    </div>
                    <p>
                      <b>Premièrement, l’origine</b>: il s’agit ici de savoir
                      qui a le droit et qui n’a pas le droit d’être Suisse.
                      Après la naturalisation et le début de sa carrière en
                      tennis, le thème de l’origine a été déplacé. La question
                      n’était plus de savoir si elle appartenait au pays, la
                      question était désormais d’établir si elle représentait
                      réellement la Suisse. Donc de savoir si ses manières, ce
                      qu’elle montrait publiquement, correspondait à l’image que
                      l’on se fait généralement du pays. Skenderovic poursuit:
                      «Martina Hingis avait une très grande confiance en elle.
                      Elle était tenace et connaissait le succès. Cela ne
                      correspond pas véritablement à l’idée que l’on a
                      généralement, en Suisse, des jeunes gens devenus
                      personnages publiques; Martina Hingis a été, d’une
                      certaine façon, punie pour son comportement rebelle.»
                    </p>
                    <p>
                      <b>Deuxièmement, le genre</b>: le thème est souvent plus
                      subtil que la question de l’origine, il est donc plus
                      difficile de le nommer. Ni Martina Hingis, ni sa mère ne
                      parlent d’attaques directes. Néanmoins, les articles et
                      les lettres de lecteurs où il est fait état d’une jeune
                      femme «élevée toute seule», par une maman «sévère» et «aux
                      ambitions démesurées» sont nombreux. Et lorsque l’on
                      proposait de soutenir financièrement Martina Hingis, à
                      condition qu’elle poursuive sa carrière sans sa maman,
                      était-ce un manque de confiance pour la maman... parce
                      qu’elle était une femme?
                    </p>
                    <p>
                      «Beaucoup de femmes venues de l’Est ont vécu des
                      expériences discriminatoires semblables ou proches»,
                      reprend Skenderovic. «En Europe de l’Est, elles avaient
                      reçu une formation. Beaucoup d’entre elles étaient
                      universitaires. Le rôle de la femme dans la société y
                      était différent d’ici, comme l’image de soi. C’était une
                      opposition totale à l’image de la femme suisse qui, en
                      comparaison, vivait plus en retrait: moins de mères
                      exerçant une profession, moins de chances professionnelles
                      pour les femmes.»
                    </p>
                    <p>
                      Martina Hingis a aussi subi les qualificatifs infantiles
                      et sexualisés que connaissent toutes les stars du sport
                      féminin: «Petite étoile du tennis», «Princesse», «Jeune
                      fille miracle». Et lorsqu’elle s’est singularisée,
                      lorsqu’elle a montré qu’elle ne voulait pas être la brave
                      demoiselle, lorsque, parfois, elle se permettait d’émettre
                      son opinion, elle a directement été qualifiée de
                      grossière, quinteuse ou insolente. «C’est un stéréotype
                      classique de la discrimination du genre», explique
                      Skenderovic. «Quand des hommes se comportent ainsi, c’est
                      une preuve de force; lorsqu’une femme le fait, c’est
                      qu’elle n’est qu’une chipie.»
                    </p>
                    <p>
                      <b>Troisièmement, les capacités</b>: Skenderovic parle ici
                      d’un anti-élitisme présent en Suisse: «Paradoxalement, on
                      a mal accepté que Martina Hingis soit aussi forte. Qu’elle
                      transformait en argent ses succès en tennis, qu’elle a
                      rejoint l’élite des millionnaires du sport et, qu’en plus,
                      elle le montrait.» Les médias la présentaient avec
                      délectation montant ses propres chevaux ou roulant en
                      Porsche. Comment elle avait construit une maison à
                      Trübbach (SG), avant de déménager à Regensdorf (ZH), dans
                      une villa que «l’on remarquait plus pour ses fastes
                      nouveaux riches que pour sa simplicité architecturale».
                    </p>
                    <p>
                      Le succès de Martina Hingis était marqué par une étrange
                      concomitance: elle avait des contrats publicitaires
                      extrêmement bien dotés au Japon, aux États-Unis, en
                      Allemagne et en Italie, où on la considérait comme
                      parfaitement «compatible»; elle y était un visage facile à
                      vendre. Mais en Suisse, plutôt que de l’émerveillement,
                      elle suscitait un certain mépris. En exagérant, on peut
                      dire qu’elle était une star globale, mais une perdante
                      locale. Elle était une personne extraordinaire à l’époque
                      où, en Suisse, on préférait les gens ordinaires.
                    </p>
                    <p>
                      Skenderovic, encore: «Pour les émigrantes et les
                      émigrants, les années nonante étaient des temps difficiles
                      question identité et appartenance, spécialement pour les
                      femmes. Il y avait une crise mentale collective: la
                      votation sur l’Espace économique européen, les discussions
                      sur le rôle de la Suisse durant la Seconde Guerre
                      mondiale. En comparaison avec beaucoup d’autres pays,
                      l’image de la famille y était encore arriérée, sans parler
                      de la volonté de rester un pays provincial dans un monde
                      globalisé. Et soudainement débarque une «Global Player»
                      dans le vrai sens du terme, qui montrait un chemin
                      beaucoup plus ambitieux. Sans Hingis, Federer aurait-il
                      existé?»
                    </p>
                    <p>
                      En Suisse, Hingis se retrouve dans l’ingrate fonction de
                      charnière entre le passé et le futur. La résistance
                      qu’elle a connue est la résistance de la Suisse des années
                      nonante à une évolution sociale qui n’allait pas s’arrêter
                      aux frontières.
                    </p>
                    <p>
                      L’histoire de Martina Hingis est ainsi un peu celle de la
                      Suisse dans ses rapports avec le sport d’élite, avec
                      l’émigration et avec les femmes.
                    </p>
                  </div>
                </div>
              </Element>

              <Element className='section' name='section-4-4' id='section-4-4'>
                <div className='ta text'>
                  <div className='ui text container'>
                    <h6>Chapitre 7</h6>
                    <h5>
                    Un court hommage au tennis
                    </h5>
                    <p>
                      La différence entre le football et le tennis est simple:
                      au foot, on peut se permettre de commettre des erreurs.
                      Bien sûr, en football, la décision se fait aussi parfois
                      pour quelques centimètres. Mais on peut également réussir
                      quelque chose avec une passe imparfaite. Un centre
                      malheureux peut trouver un équipier, une mauvaise passe à
                      la relance ne se transforme pas obligatoirement en
                      auto-goal.
                    </p>
                    <p>
                      En tennis, c’est différent. «Si vous avez joué un minimum,
                      vous vous représentez certainement la difficulté de la
                      tâche. Eh bien, j’affirme que vous n’avez pas la moindre
                      idée de ce dont il s’agit réellement», écrit David Foster
                      Wallace, lui-même joueur professionnel de tennis
                      handicapé, dont le génie littéraire trouve également place
                      dans la description qu’il fait de son sport préféré. «À la
                      télévision, on ne se rend pas vraiment compte de ce que
                      font les meilleurs joueurs du monde, avec quelle force ils
                      tapent dans la balle, quel contrôle, quelle fantaisie
                      tactique, quelle maîtrise artistique ils déploient.»
                    </p>
                    <SideElement side='right'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/4-5-tennis.jpg'
                          : '../../images/4-5-tennis.jpg')}
                      />
                      <figcaption>
                        Pendant longtemps, le tennis a été considéré comme
                        artistique et subversif. Les deux sexes y jouaient,
                        souvent ensemble. Photo: Pictorial Press Ltd/Alamy Stock
                        Photo
                      </figcaption>
                    </SideElement>
                    <p>
                      Le tennis n’exige pas seulement un contrôle corporel
                      absolu, une coordination totale entre l’œil et la main, de
                      la rapidité, des capacités de réaction, de la condition
                      physique, du courage; il exige également cet étrange – car
                      si contradictoire – mix entre la prudence et le sans-gêne
                      absolu. Parfois, on doit jouer patiemment, défensivement;
                      parfois, il n’y a pas d’autre choix que l’attaque,
                      l’agressivité. Et le match revient à celui, à celle, qui
                      trouve la juste mesure. Ce n’est pas par hasard si le
                      tennis est souvent comparé aux échecs. Dans les deux arts,
                      on est seul, on prévoit plusieurs coups à l’avance. Et
                      l’on est coupable de chaque faute commise.
                    </p>
                    <p>
                      Seule la victoire compte. Celui qui perd de justesse une
                      finale n’est pas deuxième. Les demi-finalistes malheureux
                      n’occupent pas les troisième et quatrième places. Aller
                      loin, en tennis, n’est pas l’objectif. Seule la victoire
                      compte.
                    </p>
                    <p>
                      Il est d’ailleurs révélateur de se rappeler que la
                      première représentation du tennis est une image de
                      l’enfer: un abbé du monastère Morimond à
                      Fresnoy-en-Bassigny, doit avoir observé, à la fin du XIIe
                      siècle, comment des démons se renvoyaient une âme humaine
                      comme une balle avec le plat de la main. Il s’agissait de
                      moines qui, malgré une interdiction, jouèrent avec une
                      balle dans le préau du monastère et furent immédiatement
                      transformés en démons. L’abbé a décrit la scène à un ami,
                      qui la rapportera ensuite au moine cistercien Caesarius
                      von Heisterbach, scène qu’il mettra en exergue dans son
                      œuvre Dialogus miraculorum.
                    </p>
                    <p>
                      Cet ignominieux jeu de balle, c’est le «Jeu de Paume»;
                      comme son nom l’indique, il s’agissait d’une sorte de
                      tennis sans filet, ni raquette. Avec les années, le jeu a
                      fait son bout de chemin, sortant des cloîtres pour
                      rejoindre les cours des nobles. À la place de la paume de
                      la main, on jouait désormais avec un gant, bientôt avec
                      une raquette; le terrain allait ensuite être séparé en
                      deux par un filet et entouré de lignes. Entre parenthèses:
                      le mot raquette provient de l’arabe, «rakhat», qui
                      signifie «surface à l’intérieur de la main».
                    </p>
                    <p>
                      Mais d’où vient l'appellation «tennis»? Son étymologie est
                      énigmatique. Une explication plausible est, qu’en France,
                      avant chaque service, on criait: «Tenez!». Une forme de
                      prévenance pour l’adversaire: «Attention, la balle
                      arrive.» Aujourd’hui encore, on «prévient» nos adversaires
                      en criant, avant l’engagement, le score de la partie.
                    </p>
                    <p>
                      En ne changeant que quelques lettres, «tenez» en français
                      va bientôt devenir «tenys» en italien, et enfin «tennis»
                      en anglais. Autrefois, il s’agissait encore d’un sport
                      d’équipe dont la brutalité mentale a peut-être influencé
                      le jeu moderne. Ainsi, dans une ballade du Moyen- ge, le
                      moine John Lydgate compare, en 1536, la bataille
                      d’Azincourt lors de la Guerre de 100 ans à une partie de
                      tennis!
                    </p>
                    <p>
                      Partout, dans les cours nobles d’Europe, on allait bientôt
                      construire des «maisons de la balle», où l’on pouvait
                      s’entraîner. C’est dans un tel lieu que, le 20 juin 1789 à
                      Versailles, allait se tenir un des événements décisifs de
                      la Révolution française: le «Serment du Jeu de Paume».
                      Trois cents députés du Tiers-État – bourgeois, paysans et
                      artisans –, jurèrent de «ne jamais se séparer et de se
                      rassembler partout où les circonstances l’exigeront,
                      jusqu’à ce que la Constitution du royaume soit établie et
                      affermie sur des fondements solides. Nous ne céderons qu’à
                      la force de la baïonnette.» Celui qui dit que le tennis
                      est plus qu’un sport n’a donc pas tort.
                    </p>
                    <p>
                      Le sport ne s’est pas seulement développé dans les
                      «maisons de balle» de la haute société, mais aussi sur des
                      places publiques – le «tennis de rue»; dans les prisons où
                      étaient enfermés ceux qui ne payaient pas leurs dus, on
                      parlait de «sport de la raquette», une sorte d’ancêtre du
                      squash d’aujourd’hui.
                    </p>
                    <p>
                      Le tennis moderne résulte de deux évolutions fort
                      différentes, mais survenues presque au même moment: en
                      1830, Edwin Budding invente la tondeuse à gazon; en 1839,
                      Charles Goodyear découvre la vulcanisation. Ce n’est
                      qu’après cette dernière découverte qu’il fut possible de
                      fabriquer des balles qui résistent à l’humidité et à la
                      boue, tout en conservant de bonnes propriétés de rebond.
                      Et grâce à la tondeuse, on pouvait désormais déplacer le
                      jeu des terrains en sable vers des pelouses parfaitement
                      planes.
                    </p>
                    <p>
                      La plupart des disciplines sportives populaires de l’ère
                      victorienne, en Grande-Bretagne, étaient des affaires
                      plutôt brutales, comme le rugby, le cricket et le
                      football. Au contraire, le tennis était plus artistique,
                      plus subversif aussi. Les gens des deux sexes le
                      pratiquaient, parfois même ensemble. On ne gagnait pas un
                      match avec la force et l’endurance. On le remportait grâce
                      à l'habileté, l’adresse. Petit à petit se développèrent
                      des règles, des championnats et l’on commença à mettre en
                      exergue des résultats, des records, quelque chose qui, au
                      Moyen- ge et durant la Renaissance, ne signifiait rien du
                      tout.
                    </p>
                    <p>
                      Un major du nom de Walter Clopton Wingfield apporta
                      finalement une méticulosité qui est encore aujourd’hui
                      valable, faisant d’un spectacle hors la loi un système
                      fermé, au sein duquel des règles strictes devaient être
                      suivies. Les infractions n’étaient pas seulement montrées,
                      on les criait: «Out!»
                    </p>
                  </div>
                </div>
              </Element>
            </div>

            <div className='ui vertical segment' style={{ padding: '0' }}>
              <Element className='section' name='section-5' id='section-5'>
                <SegmentHeader
                  part='Troisième partie'
                  title='Au sommet'
                  image={require(isMobile
                    ? '../../images/5-wimbledon.jpg'
                    : '../../images/5-wimbledon-desktop.jpg')}
                  caption='Photo: Chris Smith (PopperPhoto/Getty Images)'
                />
              </Element>

              <Element className='section' name='section-5-1' id='section-5-1'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Chapitre 8</h6>
                    <h5>1997, année de folie</h5>
                    <p>
                      Lorsque, le 4 octobre 1994 à Zurich, Martina Hingis fait
                      ses débuts sur le circuit professionnel du tennis féminin
                      (la WTA), elle vient de fêter ses 14 ans. Son adversaire,
                      plus âgée qu’elle de quinze ans, est une Américaine, Patty
                      Fendick, alors classée au 45e rang mondial. No 45? Ce
                      n’est pas très impressionnant. Mais cela signifie quand
                      même que, dans le monde, il n’y avait que 44 joueuses
                      meilleures qu’elle!
                    </p>
                    <p>
                      Depuis plus d’une année, le monde du tennis discute
                      intensément d’une question: quel doit être l’âge minimum
                      pour qu’une joueuse puisse être autorisée à tenter sa
                      chance sur le tour professionnel?
                    </p>
                    <p>
                      Au printemps 1993, Hingis était devenue la plus jeune
                      joueuse de l’histoire de Roland-Garros, Grand Chelem de
                      Paris, à remporter le titre junior. Elle avait 12 ans, son
                      adversaire 18. Le quotidien «Le Monde» écrivait alors:
                      «Elle est plus petite que les demoiselles qui ramassent
                      pour elle les balles sur le court. On pourrait jurer
                      qu’elle peine à soulever sa raquette, mais elle joue et
                      elle gagne avec une lucidité ahurissante.»
                    </p>
                    <p>
                      Martina Navrátilová, 36 ans à l’époque, celle qui a donné
                      son prénom à Hingis, était alors sceptique devant la
                      Suissesse qui se profilait déjà comme sa successeur: «Je
                      ne pourrais pas exiger cela de mon enfant de 12 ans. C’est
                      un monde d’adultes et à 12 ans, c’est extrêmement
                      difficile d’essayer d’y vivre. C’est trop tôt. C’est trop
                      de pression.»
                    </p>
                    <p>
                      Cela faisait longtemps que Navrátilová était une icône,
                      sur les courts et au-dehors. Au début des années 1980,
                      elle avait été une des premières stars du sport à faire
                      son coming-out; entre 1978 et 1990, elle remporta dix-huit
                      titres en simple dans des tournois du Grand Chelem. Ses
                      mots comptaient.
                    </p>
                    <p>
                      En réponse au jugement de Navrátilová, Martina Hingis, 12
                      ans, répondit: «Je ne la juge pas, pourquoi me
                      juge-t-elle? Je ne pense pas qu’elle soit trop âgée pour
                      jouer, pourquoi pense-t-elle que je suis trop jeune?»
                    </p>
                    <p>
                      Aussi intelligente que cette réponse puisse paraître,
                      Navrátilová n’était pas pour autant totalement à côté de
                      ses pompes. En 1990, juste avant son quatorzième
                      anniversaire, Jennifer Capriati avait obtenu une
                      autorisation spéciale pour devenir professionnelle. Les
                      années suivantes, la moitié du monde regardait ce
                      qu’allait devenir cette jeunesse placée si tôt sous le feu
                      des projecteurs: vols à l’étalage, haschisch, dépressions,
                      avant la fin prématurée de sa carrière.
                    </p>
                    <SideElement side='right'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/5-1-paris_1994.jpg'
                          : '../../images/5-1-paris_1994-desktop.jpg')}
                      />
                      <figcaption>
                        «Elle est plus petite que les filles qui vont chercher
                        ses balles sur le court de tennis. Mais elle joue et
                        gagne avec une étonnante clairvoyance», écrivait «Le
                        Monde» en 1993. Photo: Keystone/InterPhoto/Lookback
                      </figcaption>
                    </SideElement>
                    <p>
                      Que Martina Hingis puisse être compétitive face aux
                      professionnelles, là n’était pas la question. La question
                      était: est-ce qu’une jeune fille de son âge était
                      psychologiquement prête à affronter le tour pro?
                    </p>
                    <p>En 1993, sa maman avait dit non.</p>
                    <p>
                      Une année plus tard, alors qu’elle venait d’avoir 13 ans,
                      Hingis défend victorieusement son titre parisien et
                      remporte un autre tournoi du Grand Chelem en junior, celui
                      de Wimbledon.
                    </p>
                    <p>Désormais, elle est prête, a alors estimé sa maman.</p>
                    <p>
                      Qui confie: «Tout ce théâtre était complètement exagéré.
                      Martina était la meilleure junior du monde, pourquoi
                      n’aurait-elle pas le droit de jouer contre des adultes?
                      Peut-être qu’elle perdrait, peut-être qu’elle gagnerait,
                      on ne sait jamais cela par avance.»
                    </p>
                    <SideElement side='left'>
                      <VideoPlayer
                        mp4={require('../../videos/05-wimbledon-1996-fr.mp4')}
                        posterImage={require('../../videos/05-wimbledon-1996.jpg')}
                        caption='Première victoire en Grand Chelem: 1996 en double avec Helena Suková. Source: Wimbledon'
                      />
                    </SideElement>
                    <p>
                      Le 4 octobre 1994, Martina Hingis est donc entrée sur le
                      court de la Saalsporthalle zurichoise, pour y affronter
                      Patty Fendick, son premier match chez les
                      professionnelles. Dans les tribunes, des milliers de
                      curieux, des journalistes du monde entier. La plupart
                      d’entre eux pensaient que la réalité allait ramener Hingis
                      sur terre. Même les deux ramasseuses de balles à peine
                      plus jeunes qu’elle, interviewées par la télévision
                      alémanique avant le match, n’y croyaient pas: «Je pense
                      qu’elle va perdre. Ce sera sûrement une jolie partie, mais
                      elle n’a que très peu de chances», expliqua l’une d’elles.
                      «Je crois aussi qu’elle va perdre. Elle a assurément
                      beaucoup de talent pour son âge, mais comme beaucoup
                      d’autres avant elle», répondit la seconde.
                    </p>
                    <p>
                      En apparaissant sur le court aux côtés de Fendick, Martina
                      Hingis se tenait la tête bien droite. Ce n’était pas de
                      l’arrogance, mais plutôt l’expression d’une joie longtemps
                      attendue. La partie a commencé comme la plupart des gens
                      l’imaginaient: Hingis a perdu d’emblée son service. Elle
                      semblait instable, nerveuse. Mais, petit à petit, quelque
                      chose d’imperceptible s’est passé.
                    </p>
                    <p>
                      Hingis ne frappait pas les balles plus violemment que
                      Fendick, elle ne réussissait pas des points directs, ce
                      n’était pas elle qui dictait le jeu. Parce que ses coups
                      manquaient de force et de précision. Mais elle analysait
                      les plans de Fendick et commençait à provoquer de plus en
                      plus de fautes dans le jeu d’une adversaire pourtant bien
                      plus expérimentée. Elle ne jouait pas encore de façon
                      spectaculaire, non, mais elle réussissait juste le coup
                      exact au moment idoine. Dès ses premiers pas chez les
                      «grandes», on découvrait ce qui allait devenir sa marque
                      de fabrique: elle se déplaçait sur le court avec la grâce
                      d’une danseuse et elle jouait avec la roublardise d’une
                      voleuse à la tire.
                    </p>
                    <p>Hingis s’est imposé 6-4, 6-3 en à peine 66 minutes.</p>
                    <p>
                      Il est important de se rappeler que malgré son talent de
                      surdouée, tout ne s’est pas réalisé du premier coup. Elle
                      va d’ailleurs perdre le match suivant, face à Mary Pierce.
                      Et beaucoup d’autres, ensuite. Il a fallu attendre deux
                      ans pour qu’elle remporte son premier tournoi chez les
                      professionnelles, celui de double à Wimbledon, en 1996,
                      aux côtés d’Helena Suková; cela faisait d’elle la plus
                      jeune lauréate de l’histoire, dans un tournoi de Grand
                      Chelem. En octobre de la même année, elle célébrait sa
                      première victoire en simple, à Filderstadt.
                    </p>
                    <SideElement side='right'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/5-2-australien.jpg'
                          : '../../images/5-2-australien.jpg')}
                      />
                      <figcaption>
                        Tous les regards sont tournés vers elle: Hingis remporte
                        l'Open d'Australie en 1997 à l'âge de 16 ans. Photo:
                        Eddy Risch
                      </figcaption>
                    </SideElement>
                    <p>
                      Ces deux succès avaient pourtant été précédés d’une grande
                      discorde entre mère et fille. En mai 1996, à Key Biscayne,
                      en Floride, Martina s’était montrée tant désintéressée et
                      indifférente lors de son premier match contre une joueuse
                      placée 85 rangs derrière elle au classement mondial que
                      Melanie Molitor avait formulé un ultimatum: une carrière
                      au tennis, ou le retour à l’école (qu’Hingis avait quittée
                      à l’âge de 14 ans).
                    </p>
                    <p>
                      «Ce fut un tournant», explique Martina Hingis. «Nous
                      n’étions pas très contentes l’une avec l’autre.»
                    </p>
                    <p>
                      Et Melanie Molitor rappelle souvent: «Quand les enfants
                      sont petits, une mère ne peut pas vraiment se représenter
                      les problèmes que provoque la puberté. Nous nous sommes
                      bagarrées pendant des mois. Je n’avais juste pas vu venir
                      qu’il était beaucoup plus important pour Martina d’être
                      une personne indépendante qu’une bonne joueuse de tennis.
                      Jusque-là, je l’avais complètement influencée; désormais,
                      elle se forgeait sa propre personnalité, elle ne voulait
                      pas s’entraîner. Elle croyait que le succès venait comme
                      ça, simplement. J’ai alors dû lui faire comprendre que,
                      pour moi, le tennis n’avait jamais été la chose la plus
                      importante, je le voyais juste comme la chance d’avoir une
                      meilleure vie. Je lui ai encore dit que si elle ne
                      saisissait pas cette chance, je continuerais toujours de
                      l’aimer. «Je t’ai appris le tennis, mais si tu ne veux pas
                      faire cela, ne joue pas. En Suisse, tu as beaucoup
                      d’autres possibilités.»
                    </p>
                    <p>
                      Hingis ne répondit pas grand-chose – elle ne parle pas
                      beaucoup dans les moments importants –, mais le message
                      était passé. Elle augmente alors son pensum d’entraînement
                      quotidien de 1,5 à 2,5 heures, commence à pratiquer
                      l’aérobic et la boxe dans le vide.
                    </p>
                    <p>
                      La suite? Demi-finale à l’US Open, victoire au tournoi de
                      Filderstadt, finale à Zurich, en demi à Chicago et titre à
                      Oakland.
                    </p>
                    <p>
                      Puis 1997, l’année de folie. En janvier, à Melbourne,
                      Martina Hingis devient la plus jeune joueuse du XXe siècle
                      à remporter l’Australian Open. Le 31 mars, elle est la
                      plus jeune joueuse de l’histoire à occuper la première
                      place du classement mondial. En juillet, elle gagne
                      Wimbledon, en août, l’US Open. Des quatre tournois du
                      Grand Chelem, seul le Roland-Garros, à Paris, lui échappe,
                      après une défaite surprenante en finale face à Iva Majoli.
                      Bien plus tard, elle répétait encore: «Le réservoir était
                      vide...»
                    </p>
                    <p>
                      1997 fut aussi l’année de ses 17 ans. Par comparaison: la
                      numéro un mondiale de l’époque, Ashleigh Barty, avait 23
                      ans lorsqu’elle a remporté son premier tournoi de Grand
                      Chelem.
                    </p>
                    <p>
                      Martina Hingis était devenue la meilleure joueuse de
                      tennis au monde. Mais les accrochages entre mère et fille
                      se poursuivaient. Alors, pour quelques temps, Hingis
                      décida de poursuivre sa carrière sans sa maman.
                    </p>
                    <p>
                      «Je pense que je voulais lui montrer que j’étais capable
                      de le faire sans elle», nous raconte-t-elle à propos de
                      son initiative individuelle des années 1998 et 2001. «Ou,
                      peut-être, que je voulais m’en persuader moi-même? Maman
                      n’a certes pas sauté de joie, mais elle a laissé faire. Ce
                      n’était pas une vraie dispute entre nous. D’ailleurs,
                      après chaque match, je l’appelais: «Heey, j’ai gagné!» Et
                      elle répondait: «Oui, oui...» Elle regardait bien sûr tous
                      les matches à la télévision. Elle se réjouissait pour moi,
                      mais elle pensait, au fond d’elle-même, qu’avec elle
                      j’aurais atteint la finale de tel ou tel tournoi, que je
                      ne me serais pas arrêtée en demi. Et rapidement, j’ai
                      remarqué qu’il m’était difficile d’être toujours en voyage
                      sans elle. J’avais de la peine à me motiver à
                      l’entraînement; pour cela, j’avais besoin d’elle.»
                    </p>
                    <p>
                      Et de poursuivre, après une pause: «À la fin, on revient
                      toujours aux solutions qui fonctionnent le mieux. Il était
                      désormais évident pour moi que ma mère était la personne à
                      laquelle je pouvais le mieux confier ma vie.»
                    </p>
                    <p>
                      Il est d’ailleurs remarquable que cette relation entre
                      Martina Hingis et Melanie Molitor soit restée aussi
                      étroite durant une si longue période. D’autant plus
                      lorsqu’on se remémore combien de gens, pendant les années
                      nonante, ont laissé entendre que ladite relation était
                      définitivement déchirée.
                    </p>
                    <p>
                      D’ailleurs, celui qui le souhaite peut s’en convaincre en
                      faisant un petit test dans son entourage: demandez
                      séparément à vos proches ce qu’ils pensent de la maman de
                      Martina Hingis. Les réponses les plus probables devraient
                      être proches de ces mots: «La mamie du tennis», «pas
                      sympathique», «obstinée».
                    </p>
                    <p>
                      Renforcée par d’innombrables articles de presse, l’image
                      négative de Melanie Molitor s’est propagée dans la
                      conscience suisse: celle d’une préceptrice sans cœur
                      désirant vivre à travers sa petite fille sauvage le rêve
                      qu’elle n’avait jamais pu atteindre elle-même.
                    </p>
                    <p>
                      Confrontée à ce reproche sévère, Melanie Molitor répond:
                      «Martina a toujours été libre. Pour moi, c’était
                      important. Je voulais qu’elle soit libre et j’acceptais
                      ses décisions sans détours.»
                    </p>
                    <p>
                      Ce rapport de force entre les deux femmes était totalement
                      opposé à ce que le public imaginait: Molitor ne voulait
                      pas façonner Martina selon ses propres idées, elle voulait
                      juste que la personnalité de sa fille puisse s’exprimer
                      sur le court: «Tu joues comme tu vis», dit-elle encore. Ce
                      qui signifie que si l’on aime le culot et la jouerie de
                      Martina sur le court, il faut aussi accepter un certain
                      non-conformisme en-dehors du terrain. L’un ne va pas sans
                      l’autre.
                    </p>
                    <p>
                      C’est peut-être là que s’est faite la différence par
                      rapport à un André Agassi ou à une Tracy Austin, qui tous
                      les deux également se retrouvèrent dans le monde
                      professionnel alors qu’ils n’étaient encore que des
                      adolescents, forcés par leurs parents. Malgré leurs
                      succès, ils semblaient souffrir du tennis comme d’une
                      grave maladie, à un point tel que tous les deux furent
                      soulagés lorsque cela s’est terminé. Pour Martina Hingis,
                      c’est différent: aujourd’hui encore, c’est sur un court de
                      tennis, et nulle part ailleurs, qu’elle se sent le mieux.
                    </p>
                    <p>
                      C’est naturellement l’une des platitudes les plus extrêmes
                      que l’on puisse écrire à propos du sport: ce qui est juste
                      est ce qui fonctionne.
                    </p>
                    <p>
                      Lors de la préparation de cet article, toutes les
                      rencontres avec Martina Hingis se sont déroulées à
                      proximité d’un lieu dédié au tennis: à Zoug, elle joue en
                      Interclub avec trois anciennes amies; à Bienne, elle
                      officie comme coach de l’équipe suisse de Fed Cup; au
                      centre de tennis de Melanie Molitor, à Wollerau, elle
                      s’entraîne avec des élèves de sa maman. La raquette en
                      mains, elle semble libérée. Quand on la voit ainsi, on ne
                      peut que penser que, pour elle, le tennis ne fut jamais
                      une charge, mais toujours une immense joie.
                    </p>
                    <p>
                      Et c’est toujours le cas. Sa présence sur un court n’est
                      pas un plongeon mélancolique dans le passé, ce n’est pas
                      une tentative désespérée de s’accrocher aux triomphes
                      d’hier. Non, Martina est juste là. Elle ne regarde pas
                      derrière elle, pas devant non plus, elle n’a pas
                      d’attentes. Elle est simplement sur le court et profite du
                      jeu.
                    </p>
                    <p>
                      En 1997, soit cinq ans après ses critiques initiales à
                      l’encontre de la Suissesse, Martina Navrátilová parlait
                      différemment de Martina Hingis. Dans une interview à une
                      journaliste du magazine américain «Sports Illustrated»,
                      elle confiait: «Si j’avais une fille, j’essaierais de la
                      retenir le plus longtemps, pour qu’elle ne joue pas
                      autant, si tôt. Mais la maman de Martina s’est montrée
                      très clairvoyante avec elle. Elle lui a permis de
                      construire sa vie. Martina est une fille du tennis, mais
                      pour sa mère, elle est d’abord une fille.»
                    </p>
                    <div style={{ marginTop: '2em' }}>
                      <VideoPlayer
                        mp4={require('../../videos/06-wahnsinnsjahr-1997-fr.mp4')}
                        posterImage={require('../../videos/06-wahnsinnsjahr-1997.jpg')}
                        caption='Sa meilleure année: 1997.'
                      />
                    </div>
                  </div>
                </div>
              </Element>

              <Element className='section' name='section-5-2' id='section-5-2'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Chapitre 9</h6>
                    <h5>Pourquoi est-ce que l’on compte si bizarrement en tennis?</h5>
                    <p>
                      Le tennis est un sport capricieux, riche de mystères et de
                      contradictions. Prenez la manière de compter les points,
                      la plus bizarre de tout le monde du sport organisé: Love
                      (zéro), 15, 30, 40, jeu. Certains disent que ce système
                      d'attribution des points s’inspire des quarts d’heure.
                      Mais dans ce cas, pourquoi 40 et pas 45?
                    </p>
                    <p>
                      D’autres affirment que c’est l’héritage d’une forme très
                      ancienne du tennis où, à chaque point gagné, on avançait
                      de 15 pieds sur le terrain. Même remarque: pourquoi 40 et
                      pas 45? Simplement, pour les teneurs de cette explication,
                      parce qu’avec 45 pieds... on se retrouvait trop proche du
                      filet!
                    </p>
                    <p>
                      L’utilisation de «love» pour signifier zéro est encore
                      plus énigmatique. Une théorie place son origine au XVIe
                      siècle, lorsque des protestants et protestantes
                      néerlandais fuirent en Angleterre pendant les guerres de
                      religion et, tant démunis qu’ils étaient, ne jouèrent pas
                      pour l’argent, mais bien pour le seul honneur («iets voor
                      lof doen»).
                    </p>
                    <p>
                      Une autre explication penche sur le fait que le chiffre 0
                      ressemble à un œuf. «L’œuf» prononcé avec l’accent
                      britannique pouvant devenir «love».
                    </p>
                    <p>
                      Ces deux théories semblent plausibles, mais il y a encore
                      beaucoup plus fascinant: en raison de cette ponctuation
                      particulière et du découpage en jeu, sets et match, une
                      joueuse qui a marqué plus de points que son adversaire sur
                      l’ensemble de la partie... peut perdre! C’est le «paradoxe
                      de Simpson». L’exemple le plus compréhensif est celui-ci:
                      0-6, 7-5, 7-5! Ici, la perdante a remporté 16 jeux, la
                      lauréate 14 seulement!
                    </p>
                    <p>
                      Pire encore: chaque point n’a pas la même valeur! 5-5,
                      15-30, deuxième service est un moment dramatique du jeu.
                      En comparaison, le point précédent est moins important!
                      Mais il est néanmoins faux de ne prendre en considération
                      que les «big points», parce que ceux-ci trouvent toujours
                      leur importance dans les points gagnés précédemment.
                    </p>
                    <p>
                      Souvent, on mesure les grands champions à leurs facultés
                      de jouer les points décisifs, mais il ne faut jamais
                      oublier que l’instant décisif ne serait pas, sans tous les
                      instants précédents.
                    </p>
                  </div>
                </div>
              </Element>

              <Element className='section' name='section-5-3' id='section-5-3'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Chapitre 10</h6>
                    <h5>Même la pire journée a une fin</h5>
                    <p>
                      Le 5 juin 1999, Paris fut le théâtre d’un interminable
                      duel: en finale de l’Open de France, Martina Hingis, 18
                      ans, affronte Steffi Graf, 30 ans. L’une des deux
                      joueuses, Martina Hingis, voulait remporter le seul titre
                      du Grand Chelem qui manquait à son palmarès; l’autre,
                      Steffi Graf, était la plus grande joueuse au monde depuis
                      Martina Navrátilová qui, en quelque sorte, faisait sa
                      tournée d’adieux. Elle avait déjà gagné 21 titres du Grand
                      Chelem, sa carrière avait été marquée par des blessures
                      et, depuis trois ans, elle n’avait plus atteint une
                      finale.
                    </p>
                    <p>
                      Cette rencontre va creuser encore la relation de désamour
                      entre Hingis et l’opinion publique suisse. Néanmoins,
                      durant nos entretiens, nous n’avons pas trouvé – et de
                      loin – ce comportement, celui autour duquel on a tant
                      débattu à son encontre.
                    </p>
                    <p>
                      (C’est l’une des nombreuses incohérences de l’existence
                      humaine: on ne se croit pas capable de s’adresser
                      directement à l’opinion publique ou aux critiques. Que ce
                      soit avec ses propres parents ou avec la No 1 mondiale.
                      L’explication est banale: on ne veut pas blesser l’autre,
                      on ne veut pas provoquer un conflit ou précipiter une
                      rupture.)
                    </p>
                    <p>
                      C’est un joli jour d’automne. Nous sommes sur la terrasse
                      de l’un de ses restaurants préférés. Martina Hingis se met
                      soudainement, d’elle-même, à parler de cet instant.
                    </p>
                    <p>
                      «Cela faisait des mois que la sauce montait. On répétait
                      toujours que je ne serais jamais devenue No 1 si Steffi ne
                      s’était pas blessée. Je savais quelle était l’opinion des
                      gens et je voulais prouver qu’ils se trompaient. J’avais
                      déjà battu trois fois Steffi, deux fois à Tokyo, une fois
                      à Rome; mais ce match, je voulais plus que tout le gagner,
                      plus qu’aucun autre auparavant. Je voulais impérativement
                      la battre, lui prendre ce titre.»
                    </p>
                    <p>
                      Le fait que l’Allemande était parvenue à se qualifier pour
                      la finale en battant difficilement Lindsay Davenport, la
                      numéro 2, et Monica Seles, la numéro 3 du classement
                      mondial, tenait déjà du miracle. Et voilà qu’elle se
                      retrouvait face à la joueuse amenée à lui succéder.
                    </p>
                    <p>
                      C’était un duel de deux générations, de deux styles de
                      jeu. D’un côté, Graf, dont le surnom, «Mademoiselle Coup
                      Droit», disait tout de son coup préféré, tellement
                      destructeur que ses adversaires n’avaient pas le choix,
                      elles ne pouvaient qu’essayer de se défendre durant tout
                      un match. Elle disposait aussi d’un jeu de jambes
                      incroyable et d’un revers slicé parfait.
                    </p>
                    <p>
                      De l’autre côté, Martina Hingis, qui jouait au tennis
                      comme si le terme «toucher de balle» avait été inventé
                      uniquement pour elle.
                    </p>
                    <p>
                      «Toucher de balle», quelle belle formule! Elle ne signifie
                      pas seulement la pureté du contact avec la balle, pas
                      seulement la capacité de tenir la raquette dans l’angle
                      idéal, pas seulement de délivrer la puissance exacte; non,
                      c’est beaucoup plus que cela. Cela veut aussi dire avoir
                      la capacité de faire passer sans la moindre peine
                      au-dessus du filet des balles que l’adversaire ne va
                      reprendre qu’après de grands efforts. Hingis avait le
                      «toucher de balle». Ce qui était difficile pour les autres
                      ne l’était pas pour elle.
                    </p>
                    <p>
                      Les deux antipodes d’un sport s’affrontaient donc à Paris.
                      Hingis était la favorite, même si Graf n’avait encore
                      jamais été battue dans une finale de tournoi du Grand
                      Chelem.
                    </p>
                    <p>
                      Début 1997, Martina Hingis avait déclaré à la télévision
                      allemande: «Steffi est restée trop longtemps éloignée des
                      courts, elle ne va plus réussir à jouer au plus haut
                      niveau.» Et: «Les temps ont changé. Apparemment, seuls les
                      Allemands ne peuvent pas le comprendre.» Cela sonnait
                      comme de la vantardise, mais, honnêtement, c’était tout à
                      fait vraisemblable. Hingis avait véritablement le
                      sentiment qu’elle était meilleure et que le temps de Graf
                      était passé.
                    </p>
                    <p>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/5-3-paris-1999.jpg'
                          : '../../images/5-3-paris-1999.jpg')}
                      />
                      <figcaption>
                        Nulle part ailleurs on ne se sent plus seul que sur un
                        court de tennis. Photo: Al Bello (Staff/Getty Images)
                      </figcaption>
                    </p>
                    <p>
                      On peut faire deux lectures différentes de cette finale.
                      La première dans les déclarations de Graf qui, après coup,
                      a avoué: «Ce fut le plus beau moment de ma carrière.»
                      L’autre lecture est bien sûr celle de Martina Hingis qui,
                      les larmes aux yeux, explique au public français: «Je
                      reviendrai l’année prochaine et peut-être qu’alors vous
                      serez de mon côté.»
                    </p>
                    <p>Qu’était-il arrivé?</p>
                    <p>
                      En comparaison à Wimbledon, les coulisses du tournoi de
                      Roland-Garros sont vivantes, colorées, bruyantes. Le
                      public est indifférent aux pénibles règles du sport. On
                      entend des exclamations, des encouragements, mais aussi
                      des sifflets. Le «silence, s’il vous plaît!» des arbitres
                      est souvent ignoré.
                    </p>
                    <p>
                      En ce samedi après-midi ensoleillé, la majorité des 16'000
                      spectateurs et spectatrices de la finale qui se pressent
                      autour du court Philippe-Chatrier sont fascinés à l’idée
                      de voir une quintuple lauréate du French Open l’emporter
                      une dernière fois. Face à cette adolescente qui bouscule
                      la hiérarchie.
                    </p>
                    <SideElement side='left'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/5-4-paris-1999.jpg'
                          : '../../images/5-4-paris-1999-desktop.jpg')}
                      />
                      <figcaption>
                        La discussion avec l'arbitre n'a jamais abouti. Photo:
                        Thomas Coex (Keystone/AFP)
                      </figcaption>
                    </SideElement>
                    <p>
                      Mais Hingis ne se laisse pas pour autant influencer. Dès
                      le premier jeu, son plan est clair: comme des centaines de
                      joueuses avant elle, elle joue sur le revers de Graf. Mais
                      à la différence de la centaine de joueuses avant Hingis,
                      Graf ne réussit que rarement à renvoyer la balle. Les
                      coups sur la ligne d’Hingis sont trop précis, trop longs;
                      trop souvent les amortis et les attaques au filet d’Hingis
                      font mouche, quand elle ne varie pas ses coups droit. Et
                      dès que Graf a besoin d’une seconde balle de service, on
                      retrouve Hingis à l’affût comme un serpent, un bon mètre à
                      l’intérieur du terrain.
                    </p>
                    <p>
                      En quelques mots: elle joue comme une routinière qui
                      connaît exactement ses forces et qui a détecté les
                      faiblesses de son adversaire.
                    </p>
                    <p>
                      Elle gagne extrêmement facilement le premier set. Au
                      deuxième, après un break, elle mène 2 à 0. Le public sent
                      que l’Allemande s’effondre et commence à crier: «Steffi,
                      Steffi!» Au troisième jeu, la juge de ligne signifie un
                      retour d’Hingis «out», une décision douteuse pour Martina,
                      qui demande à l’arbitre de descendre de sa chaise pour
                      venir contrôler l’impact de la balle.
                    </p>
                    <SideElement side='right'>
                      <VideoPlayer
                        mp4={require('../../videos/07-roland-garros-1999-fr.mp4')}
                        posterImage={require('../../videos/07-roland-garros-1999.jpg')}
                        caption='La balle était-elle sortie? Source: Roland-Garros'
                      />
                    </SideElement>
                    <p>
                      L’arbitre confirme la décision. Et à ce moment, à l’âge de
                      18 ans, Hingis commet une erreur que, vingt-deux ans plus
                      tard, elle a toujours en tête. Au lieu d’accepter la
                      décision – cela faisait alors 0-15, Hingis pouvait encore
                      gagner sans problème son jeu de service –, au lieu de se
                      concentrer sur le prochain point, elle se rend du côté de
                      son adversaire – un tabou absolu en tennis – pour vérifier
                      elle-même l’impact de la balle.
                    </p>
                    <p>
                      L’arbitre couche sur ses positions: la balle est dehors!
                      Hingis s’approche de sa chaise comme une gamine rageuse.
                      Et seule la menace d’une disqualification la convainc de
                      reprendre le jeu.
                    </p>
                    <p>
                      Le public est hors de lui, il ne fête pas seulement sa
                      «Steffi», mais il hue, invective la Suissesse.
                    </p>
                    <p>
                      À ce stade de l’histoire, il est important de relever
                      trois points.
                    </p>
                    <p>
                      Premièrement: sur les images au ralenti, on voit
                      clairement que la balle d’Hingis touche la ligne; on peut
                      dès lors se demander si ce n’est pas plutôt Steffi Graf
                      qui a commis un acte antisportif, en n’acceptant pas que
                      la balle était bonne. Elle était plus âgée de douze ans
                      que Martina Hingis et avait déjà vécu à de nombreuses fois
                      une telle situation. Pourquoi n’a-t-elle pas eu la
                      grandeur de corriger la décision arbitrale? Ainsi, elle
                      serait devenue avec raison la Reine de Roland Garros.
                    </p>
                    <SideElement side='right'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/5-5-paris-1999.jpg'
                          : '../../images/5-5-paris-1999.jpg')}
                      />
                      <figcaption>
                        Le désespoir sous les yeux de 16'000 personnes. Photo:
                        Patrick Kovarik (AFP/Getty Images)
                      </figcaption>
                    </SideElement>
                    <p>
                      Deuxièmement: cet intermède allait remettre Graf dans le
                      jeu. À 4-4, Hingis a bien réussi un nouveau break avec un
                      revers le long de la ligne qui surprit tant Graf qu’elle
                      ne tenta même pas de rattraper la balle, mais c’est bien
                      l’Allemande qui remporte finalement le set.
                    </p>
                    <p>
                      Troisièmement: Hingis avait 18 ans. À cet âge, d’autres
                      tentent de passer leur maturité; c’est aussi un moment de
                      grande pression, c’est vrai, mais personne ne vous
                      regarde. Personne ne vous hue lorsque vous commettez une
                      faute. Personne ne braque sa caméra sur votre visage
                      lorsque vous pleurez. Hingis était complètement seule
                      quand elle a craqué. Et les 16'000 spectateurs et
                      spectatrices hurlant étaient les témoins de ce moment.
                      C’est dans ces instants que l’on apprend que le tennis est
                      la plus solitaire des disciplines sportives. En boxe,
                      chacun a son coin, dans lequel l’entraîneur soulage les
                      douleurs au visage avec de la vaseline, tout en motivant
                      son protégé. Au tennis, l’entraîneur ne peut au mieux
                      qu’encourager et applaudir.
                    </p>
                    <p>
                      Dans le dernier set, Hingis perd son fameux «toucher de
                      balle». Elle va aussi perdre le contrôle de la situation.
                      Elle se perd. Chaque joueur, chaque joueuse amateur le
                      sait très bien: lorsqu’on se trouve sur le court, on se
                      souvient de soi-même d’une manière très particulière.
                      Parce que l’on découvre à la fois le plus beau, mais aussi
                      le pire côté de sa personnalité.
                    </p>
                    <p>
                      Martina Hingis s’est querellée avec l’arbitre, avec le
                      public, qui ne cesse désormais de la huer méchamment. Elle
                      est tellement frustrée qu’elle tente de résister jusqu’à
                      ses dernières forces. Sur la première balle de match de
                      Graf, elle se défend par un coup peu sportif, ce qui est
                      moins l’expression de l’arrogance qu’un aperçu de son
                      désespoir.
                    </p>
                    <SideElement side='left'>
                      <VideoPlayer
                        mp4={require('../../videos/09-roland-garros-1999-fr.mp4')}
                        posterImage={require('../../videos/09-roland-garros-1999.jpg')}
                        caption='Martina Hingis durant la cérémonie de remise des prix. Matériel: Roland-Garros'
                      />
                    </SideElement>
                    <p>
                      Et comme si elle voulait repousser la fin le plus loin
                      possible, elle sert une fois de plus la seconde balle de
                      match contre elle depuis le bas. Puis, elle lance une
                      nouvelle discussion avec l’arbitre, cette fois en raison
                      des sifflets qui descendent de la tribune. C’est alors que
                      Graf lance ces mots qui devinrent légendaires: «Are we
                      gonna play tennis or are we talking a little bit? We play
                      tennis? Okay.»
                    </p>
                    <p>
                      Hingis perd le match. Et sa contenance. Sous les cris de
                      joie des spectateurs et des spectatrices, elle quitte le
                      court en pleurs, sans attendre la cérémonie protocolaire.
                    </p>
                    <p>
                      «Si ma maman n’avait pas été là, je ne serais pas
                      revenue», nous raconte-t-elle. «Je pensais qu’ils
                      voulaient m’assassiner.»
                    </p>
                    <p>
                      Melanie Molitor explique: «Personnellement, je ne serais
                      pas revenue, je ne serais jamais revenue dans une telle
                      situation. Mais Martina, ce n’est pas moi. Et sa position
                      se serait affaiblie dans des proportions énormes si elle
                      n’était pas revenue. Si je l’ai renvoyée sur le court, si
                      je l’ai accompagnée, c’était une pure décision cérébrale,
                      parce que le cœur, les sentiments, disaient totalement
                      autre chose. Moi aussi, j’ai considéré tout cela comme un
                      manque total de fair-play.»
                    </p>
                    <p>
                      Après de longues minutes d’attente, Martina Hingis, bras
                      dessus, bras dessous avec Melanie Molitor, revient sur le
                      court. Pendant longtemps, elle reste collée à sa maman,
                      pleurant à chaudes larmes jusqu’à enfin se décider à
                      participer à la remise des prix et féliciter Steffi Graf.
                      Ensuite, elle s’approche du public et dit, en français:
                      «Je reviendrai l’année prochaine, et peut-être que vous
                      serez enfin de mon côté.»
                    </p>
                    <p>
                      Elle ne gagnera plus jamais de titre du Grand Chelem en
                      simple.
                    </p>
                    <p>
                      Depuis toutes ces années, depuis cette finale de Paris en
                      1999, on demande toujours à Hingis d’évoquer cet instant;
                      mais jamais elle n’a été en situation de pouvoir expliquer
                      totalement son comportement cet après-midi-là.
                    </p>
                    <p>
                      «Pendant longtemps, on ne comprenait pas comment je
                      fonctionnais», nous dit-elle. «Steffi était une
                      travailleuse. Une machine. Chez elle, on voyait les
                      efforts. Pas chez moi. Chez moi, tout semblait facile.»
                    </p>
                    <p>
                      Et cela ne correspondait pas à la Suisse. On ne peut pas
                      gagner en s’amusant, on doit travailler. Celui qui a de la
                      facilité devient suspect. Peut-être qu’avec Roger Federer,
                      cela a un peu changé. Nous sommes émerveillés par son
                      élégance, par sa légèreté sur le court. Et plus encore: on
                      subodore que la facilité apparente coûte des forces, que
                      la légèreté a besoin d’être entraînée. Et que des efforts
                      importants peuvent être invisibles.
                    </p>
                  </div>
                </div>
              </Element>

              <Element className='section' name='section-5-4' id='section-5-4'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Chapitre 11</h6>
                    <h5>Une tête de moins</h5>
                    <p>
                      Si Martina Hingis a joué un rôle majeur dans l’histoire du
                      tennis féminin, son jeu était néanmoins atypique à son
                      époque. Parce que, parallèlement à son avènement, débute
                      l’ère du «Power-Baseline-Tennis», comme on nomme ce jeu
                      depuis la ligne de fond qui a détrôné les spécialistes de
                      services-volées des années 80.
                    </p>
                    <p>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/5-6-kalifornien-1999.jpg'
                          : '../../images/5-6-kalifornien-1999.jpg')}
                      />
                      <figcaption>
                        1m70 contre 1m85: Martina Hingis et Venus
                        Williams en 1999. Photo: Harry How (Allsport)
                      </figcaption>
                    </p>
                    <p>
                      Le changement était important et en relation direct avec
                      une innovation technologique: l’arrivée des raquettes en
                      matières synthétiques.
                    </p>
                    <p>
                      Petite excursion, si vous le voulez bien, dans le monde de
                      la technique de la raquette. Pour le dire en quelques
                      mots, il existe en tennis deux raquettes, une pour le coup
                      droit, l’autre pour le revers. Avec chacune d’elles, on
                      peut jouer de deux manières différentes. Le topspin
                      signifie que l’on effleure la balle avec un mouvement de
                      bas en haut de la raquette, provoquant ainsi un effet de
                      rotation et, après l’impact, la balle prend beaucoup de
                      hauteur, surprenant du coup l’adversaire.
                    </p>
                    <p>
                      La deuxième variante, c’est le slice. La balle est
                      «coupée» d’un mouvement du haut vers le bas de la
                      raquette, provoquant ainsi un effet de recul. Dans le
                      slice, la trajectoire de la balle est extrêmement plate et
                      longue et, après l’impact, elle ne rebondit que très peu,
                      ce qui complique le retour pour l’adversaire.
                    </p>
                    <p>
                      Le topspin et le slice étaient utilisés depuis longtemps,
                      mais avec l’arrivée de raquettes de plus grands formats en
                      matières synthétiques, le topspin devenait plus rapide et
                      plus dangereux. L’ère du topspin mena à une sorte
                      d’uniformité dans le jeu – tout le monde utilisait le même
                      coup –, donc de plus grandes similitudes entre les
                      joueuses.
                    </p>
                    <p>
                      Les sœurs Williams sont les représentantes emblématiques
                      de cette génération de joueuses capables de proposer des
                      services fulgurants et des retours pris extrêmement
                      rapidement. Chez elles, tout était intimidant: leur
                      taille, leur corpulence, leur force, leur jeu défensif. La
                      préparation athlétique, la force musculaire et l’endurance
                      devenaient soudainement plus importants que le toucher de
                      balle, la finesse et l’inventivité.
                    </p>
                    <p>
                      D’une certaine manière, Hingis était l’antithèse de ce
                      tennis. Avec ses 170 cm, elle était simplement trop petite
                      pour tenter de résister sur le plan physique; très
                      rapidement, elle comprit qu’elle ne battrait jamais Serena
                      (181 cm), ni Venus Williams (185) avec la force, mais bien
                      avec la jouerie.
                    </p>
                    <p>
                      Les services des sœurs Williams étaient des armes. Au
                      contraire, ceux d’Hingis étaient d’une grande légèreté.
                      Ils manquaient de force, ils ne foudroyaient pas
                      l’adversaire.
                    </p>
                    <p>
                      En finale de l’US Open 1997, Martina Hingis réussit encore
                      à résister à Venus Williams, en contrôlant cette débutante
                      dont on parlait tant avec des amortis insolents et un coup
                      d’œil excellent. Deux ans plus tard, à l’automne 1999,
                      elle perdait contre la sœur, Serena Williams. Désormais,
                      la force athlétique avait pris le dessus sur la finesse.
                    </p>
                    <p>
                      C’était évidemment dans le service que ce changement de
                      paradigme était le plus visible. Les joueuses petites et
                      légères, comme Hingis, n’étaient pas capables de proposer
                      des services puissants, leur vitesse se situait
                      généralement autour des 150 km/h. C’était totalement
                      différent avec Serena Williams, dont les services moyens
                      étaient chronométrés à 170 et les meilleurs à plus de 200
                      km/h. Le service de Williams n’était plus la préparation
                      d’un point, il était le point.
                    </p>
                    <p>
                      Le service est l’un des mouvements les plus complexes,
                      techniquement, du sport. On peut peut-être le comparer
                      avec un drive au golf ou un tir à trois points en
                      basketball. L’idée de base du service est de créer le
                      maximum de problèmes pour l’adversaire. Il n’est donc pas
                      du tout question de «servir» la balle, donc l’adversaire.
                      C’est même exactement le contraire, comme l’écrit le
                      Romand Etienne Barilier: «Le but, c’est d’offrir le pire
                      des services à quelqu’un», soit placer la balle à un
                      endroit si compliqué que l’adversaire ne parvient pas à la
                      retourner.
                    </p>
                    <p>
                      Au tennis, le service lance le jeu et dicte la suite des
                      échanges. Un service injouable pour l’adversaire amène un
                      point direct; un service trop faible ou trop mal placé, et
                      c’est ce même adversaire qui dispose immédiatement d’une
                      possibilité de contre-attaque. Il est impressionnant de
                      constater l’état nerveux des joueurs et des joueuses dans
                      ce moment clef du jeu. Ivan Lendl avait toujours dans la
                      poche de son short de la sciure de bois avec laquelle il
                      frottait le manche de sa raquette. Avant de servir, Novak
                      Djokovic tape nerveusement plusieurs fois la balle et
                      Rafael Nadal... Rafael Nadal mériterait un chapitre pour
                      lui tout seul!
                    </p>
                    <p>
                      Martina Hingis était différente. Elle tapait la balle au
                      sol deux fois, peut-être trois, elle lançait un bref
                      regard et elle servait. Rien de superflu, aucun rituel.
                      Pas de ces incessants mouvements de la raquette, jamais
                      elle ne grattait le sol avec les pieds, pas de tirage
                      nerveux de son maillot, on ne la voyait jamais s’essuyer
                      le front. Non, elle servait juste la balle, comme si elle
                      était pressée de devoir le faire.
                    </p>
                    <p>
                      Début 2003, lorsque Martina Hingis se retira une première
                      fois du monde du tennis, elle n’avait que 22 ans. Elle
                      avait de plus en plus de difficultés face au «power
                      tennis» des sœurs Williams, de Lindsay Davenport et de
                      Jennifer Capriati, revenue à un niveau très élevé. Mais ce
                      qu’elle payait le plus cher, c’étaient ses débuts sur le
                      tour alors qu’elle était si jeune. Huit ans durant, dès
                      son quatorzième anniversaire, elle avait joué au plus haut
                      niveau. Elle jouait plus de vingt tournois par an, dans
                      lesquels elle devait se battre en raison de son
                      infériorité corporelle. Et comme elle ne réussissait que
                      rarement des «aces», elle était contrainte à jouer chaque
                      point, ce qui signifiait une dépense physique énorme. Son
                      style de jeu avait des conséquences: inflammations
                      chroniques au pied gauche, déchirures ligamentaires,
                      opérations.
                    </p>
                    <p>
                      Ce qui finit par la convaincre de se retirer, ce fut trois
                      défaites contre des adversaires russes en 2002: «Elles
                      étaient déjà bonnes, mais l’année suivante, elles avaient
                      véritablement explosé», nous raconte-t-elle. «Le problème,
                      c’est qu’à cette époque, je pensais: tu ne peux tout
                      simplement pas perdre contre de telles adversaires!»
                    </p>
                    <p>
                      Et il y avait autre chose: «Avez-vous vu le film
                      «Borg/McEnroe»? Je me sentais totalement comme Borg: soit
                      tu as encore la chance de gagner les plus grands tournois,
                      soit tu renonces. Je pensais exactement cela: quand tu as
                      été une fois numéro 1, tu ne veux pas être numéro 2.»
                    </p>
                    <p>
                      Hingis se retira donc à l’âge de 23 ans, parce qu’elle
                      n’était plus persuadée de pouvoir encore battre chaque
                      joueuse de la planète, comme elle l’avait fait les huit
                      années précédentes.
                    </p>
                  </div>
                </div>
              </Element>
            </div>

            <div className='ui vertical segment' style={{ padding: '0' }}>
              <Element className='section' name='section-6' id='section-6'>
                <SegmentHeader
                  part='Quatrième partie'
                  title='Le génie «Hingis»'
                  image={require(isMobile
                    ? '../../images/6-usopen.jpg'
                    : '../../images/6-australien-desktop.jpg')}
                  caption={
                    isMobile
                      ? 'Photo: Focus on Sport/Getty Images'
                      : 'Photo: Ullstein Bild/Getty Images'
                  }
                />
              </Element>

              <Element className='section' name='section-6-1' id='section-6-1'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Chapitre 12</h6>
                    <h5>Parce qu’elle aime la vie</h5>
                    <p>
                      Lors de notre première rencontre avec Martina Hingis, à
                      l’automne 2019, cela faisait deux ans qu’elle avait pris
                      sa retraite (on l’oublie trop facilement, peut-être parce
                      que c’est difficile à croire, mais elle a réussi plusieurs
                      comebacks et, à l’âge de 37 ans, elle jouait encore au
                      niveau mondial). Elle a mis au monde une fille, Lia, et
                      partage sa vie avec son mari, Harald Leemann, un médecin
                      du sport de l’Hôpital cantonal de Zoug, dans une
                      habitation zougoise avec vue sur le lac. Leemann travaille
                      beaucoup, mais Martina ne veut pas envoyer sa fille à la
                      crèche. Quand elle joue au tennis ou qu’elle monte ses
                      chevaux – les deux choses plusieurs fois par semaine –
                      c’est grand-maman Molitor qui s’occupe de la petite.
                    </p>
                    <p>
                      Il n’avait pas été facile de décrocher ce rendez-vous et,
                      à ce moment-là, nous n’imaginions pas encore qu’un jour,
                      nous écririons l’histoire de la vie de Martina Hingis.
                      Nous désirions juste une interview. Elle avait toujours,
                      nous semblait-t-il, donné l’impression de ne pas se
                      montrer particulièrement intéressée de s’expliquer dans
                      les médias.
                    </p>
                    <p>
                      Mais avec le temps, nous avons compris que ce n’était pas
                      le cas. Elle ressent un énorme besoin de se faire
                      comprendre. Malheureusement, jusque-là, elle avait
                      toujours été déçue. Elle parle volontiers d’elle, mais en
                      même temps, elle peut en avoir rapidement assez. Elle
                      aimerait raconter sa vie, mais elle redoute que la
                      perception des médias ne s’ancre, toujours, sur les mêmes
                      histoires.
                    </p>
                    <SideElement side='left'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/6-1-monica-seles.jpg'
                          : '../../images/6-1-monica-seles.jpg')}
                      />
                      <figcaption>
                        Pleine puissance à deux mains: Monica Seles à l'US Open
                        en 1991. Photo: Getty Images/Stringer
                      </figcaption>
                    </SideElement>
                    <p>
                      «Cela fait mal que l’on ne me questionne que sur mes
                      erreurs, la finale de Paris, l’affaire de la cocaïne, mes
                      histoires avec les hommes», finit-elle par nous dire près
                      d’une année et demie après notre première rencontre.
                      C’était au printemps 2021 et ce fut, pour nous, une
                      surprise totale lorsqu’elle nous appela depuis sa voiture.
                      Elle était sur le chemin du retour, après une interview
                      télévisée qui ne s’était visiblement pas déroulée comme
                      elle l’espérait; aujourd’hui, elle en est encore énervée,
                      persuadée qu’elle aurait dû la refuser. «Je le refais
                      encore et encore, mais au fond, je souffre de devoir
                      toujours me justifier.»
                    </p>
                    <p>
                      Lors de la première interview à l’automne 2019, nous
                      avions essentiellement parlé de son enfance en
                      Tchécoslovaquie. Et, pour une première fois, nous avions
                      entendu beaucoup de choses. À la fin de la rencontre, nous
                      lui avions timidement demandé si l’on pourrait
                      éventuellement se revoir une seconde fois, parce qu’il y
                      avait encore beaucoup de questions ouvertes. Elle hésita
                      un instant, avant de répondre en riant: «Et il y a aussi
                      encore beaucoup à raconter.»
                    </p>
                    <p>
                      Nous nous retrouvâmes une fois dans la halle de tennis où,
                      avec sa maman, elle entraîne des enfants. Nous voulions
                      savoir, à ses yeux, quel avait été le meilleur match de sa
                      carrière.
                    </p>
                    <p>
                      «C’était en mars 2000 contre Monica, en demi-finale du
                      tournoi de Key Biscayne. Quasi le match parfait. J’ai
                      gagné 6-0, 6-0. Elle était alors numéro 7 mondiale et je
                      l’ai...». Elle réfléchit quelques instants: «Oui, je crois
                      qu’on peut le dire ainsi: je l’ai détruite. Je crois que
                      c’était vraiment dur pour elle.»
                    </p>
                    <p>
                      Monica? C’est bien sûr l’Américaine Monica Seles, née en
                      1973 dans ce qui était alors la Yougoslavie. Lorsqu’elle
                      annonça sa retraite, en 2008, elle était peut-être la
                      joueuse la plus vénérée que le tennis ait jamais connu.
                    </p>
                    <p>
                      «Key Biscayne? Je m’en rappelle très bien», rigole Seles,
                      à l’occasion d’une rencontre via Zoom. «Martina m’a
                      totalement désossée», dit-elle dans le salon ensoleillé de
                      sa maison de Sarasota, sur la côte ouest de Floride, où
                      elle vit depuis que, en 1986, Nick Bolletieri l’a
                      découverte pour son académie. «Demandez tout ce que vous
                      désirez, ajoute-t-elle en riant, s’il s’agit de Martina,
                      j’ai tout le temps du monde.»
                    </p>
                    <p>
                      Beaucoup disent de Monica Seles qu’elle aurait pu devenir
                      la meilleure joueuse de l’histoire du tennis. Elle avait
                      14 ans lors de ses débuts sur le circuit professionnel, en
                      1989; et avant-même son vingtième anniversaire, elle avait
                      déjà remporté huit tournois du Grand Chelem. En 1991, elle
                      a ravi à Steffi Graf la place de numéro 1 mondiale qu’elle
                      avait occupée durant 186 semaines.
                    </p>
                    <p>
                      Monica Seles se rappelle aussi très bien de son premier
                      match face à Hingis. C’était à la fin de l’année 1996, en
                      finale du tournoi d’Oakland, en Californie. «Martina était
                      une enfant, mais elle jouait comme une adulte. Jusque-là,
                      je n’avais jamais rencontré une joueuse si jeune qui
                      comprenait aussi bien le jeu. Le plus étonnant était la
                      rapidité avec laquelle sa tête prenait des décisions.
                      Avant chaque match, la plupart des joueuses établissent un
                      plan et, pendant la rencontre, elles y apportent peut-être
                      une ou deux modifications. La critique, la bonne analyse
                      suivent plus tard. Au contraire, avec Martina, je me
                      rendais bien compte comment elle réfléchissait et comment
                      elle adaptait son jeu pendant que nous jouions.»
                    </p>
                    <p>
                      Hingis a remporté ce match et, ainsi, son deuxième tournoi
                      sur le circuit professionnel. Elle allait terminer la
                      saison à la place de numéro 6 mondiale, alors qu’elle
                      n’avait que 16 ans.
                    </p>
                    <p>
                      Lorsque nous avons raconté à Monica Seles qu’en Suisse,
                      Hingis avait longtemps été considérée comme une arrogante,
                      qu’on la prenait parfois comme un phénomène anormal, elle
                      n’a pas compris de quoi nous parlions, tant cela lui
                      paraissait absurde. Seles nous a alors dit: «Ce que
                      j’aimais le plus chez Martina, c’est justement qu’elle est
                      toujours restée la même, dans le succès comme dans la
                      défaite. Elle avait tellement les pieds sur terre, elle
                      n’avait pas un énorme entourage, comme d’autres joueuses
                      au sommet pouvaient en avoir. Il y avait elle, sa maman et
                      Mario. Jamais je ne l’ai vue être accompagnée par une
                      «sparring-partner»; elle s’entraînait avec les joueuses
                      qui étaient déjà sur place.»
                    </p>
                    <SideElement side='right'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/6-2-monica-seles.jpg'
                          : '../../images/6-2-monica-seles.jpg')}
                      />
                      <figcaption>
                        Comme une grande sœur: Seles avec Hingis en 1989. Photo:
                        Marcel Noecker (RDB/Ullstein Bild/Getty Images)
                      </figcaption>
                    </SideElement>
                    <p>
                      Monica Seles se sentait particulièrement bien avec Melanie
                      Molitor. Par respect, elle utilise encore le terme «Miss
                      Molitor» pour parler d’elle. En regardant Molitor, Seles
                      se rappelait de son papa Karolj qui, jusqu’à sa mort en
                      1997, était son entraîneur et l’accompagnait sur chaque
                      tournoi: «J’ai toujours dit à Martina: «Si tu ne veux plus
                      travailler avec ta maman, je l’engage immédiatement.»
                    </p>
                    <p>«Pourquoi?» demandons-nous.</p>
                    <p>
                      «Parce que, par rapport aux autres entraîneurs, hommes et
                      femmes, Miss Molitor était différente. Quand nous nous
                      entraînions ensemble, avec Martina, elle ne pensait pas:
                      «Oh, Monica est une adversaire de ma fille, je ne veux pas
                      qu’elle s’améliore.» Elle partageait son savoir, me
                      donnait des conseils, un bon feed-back, comme si elle
                      avait été mon entraîneure et pas celle de Martina. Elle
                      était modeste et désintéressée, pour elle, il n’y avait
                      que le jeu. C’est pour cela que je l’admirais tant. Vous
                      savez, sur le tour, on rencontre aussi des parents
                      totalement différents, du genre de ceux qui me criaient
                      les pires injures quand je jouais contre leur fille.»
                    </p>
                    <p>
                      Le téléphone de Monica Seles sonne. Elle se retourne –
                      c’est son mari, Tom Golisano – et nous garde en attente.
                      Au moment où nous pensons qu’elle ne reprendra pas la
                      discussion, elle apparaît à nouveau à l’écran. Car elle a
                      encore quelque chose à nous dire à propos d’Hingis.
                    </p>
                    <p>
                      «De nombreuses joueuses du circuit professionnel ne te
                      saluent même plus lorsque tu les élimines. Certaines
                      croient peut-être qu’elles doivent se comporter ainsi pour
                      connaître le succès. Martina n’a jamais été comme cela.
                      Elle avait toujours du temps pour une petite causette ou
                      un sourire. Si je devais entraîner une jeune joueuse,
                      j’aimerais vraiment qu’elle ait la même personnalité que
                      Martina: elle était compétitive, mais, dans le même temps,
                      elle savait aussi qu’avec le tennis, ce n’est pas à la
                      vie, à la mort.»
                    </p>
                    <p>
                      Seles fait une nouvelle pause. Nous pouvons imaginer ses
                      pensées. Plus que toute autre, elle sait qu’on ne peut pas
                      confondre un match et la vie. Lors d’un tournoi à
                      Hambourg, en 1993, un admirateur (malade psychiquement) de
                      Steffi Graf lui avait planté un couteau dans le dos. La
                      plaie s’est guérie, mais Monica n’a plus jamais retrouvé
                      la sérénité après cette agression. Pour elle, le tennis
                      était alors devenu secondaire.
                    </p>
                    <p>
                      Nous lui demandons de nous parler encore de ce côté
                      particulier de Martina Hingis.
                    </p>
                    <p>
                      «Regardez ses chevaux, combien elle les aimait alors
                      qu’elle était encore une jeune fille. Même quand elle
                      était numéro 1 mondiale, elle allait les monter, elle
                      skiait, elle pratiquait le skate. Un entraîneur normal lui
                      aurait interdit tout cela, en raison des risques de
                      blessures.»
                    </p>
                    <p>
                      Seles fait allusion à une autre histoire. En 1997, après
                      une chute à cheval, Hingis avait dû subir une arthroscopie
                      du genou; le déficit de condition physique qui résulta lui
                      a peut-être coûté la victoire en finale de l’Open de
                      France face à Iva Majoli et, donc, le Grand Chelem en fin
                      d’année.
                    </p>
                    <p>
                      «Martina a géré cette situation, parce qu’elle aime la
                      vie, poursuit Seles, parce qu’elle voulait également avoir
                      une vie à côté du tennis. Je crois que c’est pour cela
                      qu’elle s’est toujours entendue avec tout le monde.»
                    </p>
                  </div>
                </div>
              </Element>

              <Element className='section' name='section-6-2' id='section-6-2'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Chapitre 13</h6>
                    <h5>Trois types de vision</h5>
                    <p>
                      0-6, 0-6. Existe-t-il, dans n’importe quelle autre
                      discipline sportive, un résultat aussi explicite, aussi
                      brutal? Il signifie que tu n’as pas eu la moindre chance,
                      que tu as été battue par une adversaire nettement
                      meilleure que toi, qui devinait où tu voulais jouer la
                      balle et qui te surprenait par chacun de ses choix, même
                      quand tu étais sûre de ton fait.
                    </p>
                    <p>
                      Si Hingis estime que ce 6-0, 6-0 contre Seles a été le
                      meilleur match de sa vie, ce n’est pas parce qu’elle y a
                      «démonté» son adversaire. C’est juste parce que, ce
                      jour-là, elle a marié ses deux qualités principales à la
                      perfection: la lecture du jeu adverse et la sensation du
                      sien.
                    </p>
                    <p>
                      «Pour maman, Seles et Capriati étaient comme des points de
                      repère. Nous essayions d’imiter leur jeu et même de
                      l’améliorer. J’ai ainsi tenté de récupérer le plus
                      rapidement possible la balle, mais aussi de jouer avec
                      toujours plus de variations», explique Hingis.
                    </p>
                    <div style={{ marginTop: '2em' }}>
                      <VideoPlayer
                        mp4={require('../../videos/13-spielstil-fr.mp4')}
                        posterImage={require('../../videos/13-spielstil.jpg')}
                        caption='Lobs, balles arrêtées: une petite introduction au style de jeu de Hingis. Source: Australian Open TV, Roland-Garros, Eurosport'
                      />
                    </div>
                    <p>
                      Lors de nos recherches, nous nous sommes plusieurs fois
                      demandé pourquoi les sportifs et les sportives d’élite
                      étaient si peu éclairants au moment de décrire leurs
                      performances, quand bien même ils sont les seuls êtres
                      humains à connaître les sensations vécues durant un état
                      de grâce.
                    </p>
                    <p>
                      C’est - l’idée est de David Foster Wallace - l’antique
                      paradoxe entre créer et observer, entre «faire quelque
                      chose» et «en parler.» L’un ne va pas sans l’autre,
                      pourtant les deux ne viennent que rarement ensemble. C’est
                      peut-être aussi pourquoi les conférences de presse sont
                      souvent séduisantes mais presque toujours décevantes: on
                      espère découvrir un son original provenant du plus profond
                      du génie. Mais on ne nous livre que des banalités.
                    </p>
                    <p>
                      La spectatrice qui a observé le mieux le talent hors
                      normes de Martina Hingis, c’est évidemment sa maman. Elle
                      considère, elle aussi, que l’une des forces principales de
                      sa fille est de lire si bien le jeu de l’adversaire
                      qu’elle peut réagir dans l’instant. Cependant, elle le
                      raconte différemment.
                    </p>
                    <p>
                      «Il n’y a pas une balle que Martine ne puisse jouer. Bien
                      sûr, elle ne touche pas chaque balle, elle ne marque pas
                      chaque point. Mais il n’y a aucun coup adverse auquel elle
                      ne peut, théoriquement, donner une réponse. Son
                      infériorité physique était, une fois encore, son plus
                      grand point faible, mais nous ne pouvions rien y changer.
                      En revanche, nous pouvions travailler sur ce point.»
                    </p>
                    <p>
                      «En étant plus rapide sur ses jambes que les autres?»
                      demandons-nous.
                    </p>
                    <p>
                      «Non, répond immédiatement Molitor, elle n’était pas plus
                      rapide avec ses jambes. Elle était plus rapide dans sa
                      tête, avec ses yeux!»
                    </p>
                    <p>
                      Pour Molitor, ce point de l’importance du regard est un
                      élément central. Il ne s’agit pas seulement de se
                      positionner juste face à la balle, mais bien de la toucher
                      dans la position juste: à la hauteur de la taille,
                      légèrement sur l’avant du corps, une histoire de
                      millimètres et de microsecondes. Pour Molitor, c’est une
                      façon différente d’utiliser le regard: «Quand son
                      adversaire envoyait une balle, Martina savait déjà ce qui
                      allait se passer. C’était également le cas d’Agassi: il
                      n’était pas rapide, mais il se trouvait toujours à
                      l’endroit où la balle arrivait.»
                    </p>
                    <p>
                      Molitor parle de trois types de regards. Premièrement, on
                      doit avoir en vue la balle, sa vitesse et sa trajectoire.
                      Deuxièmement, on doit regarder l’adversaire, lire ses
                      mouvements, idéalement estimer les effets qu’elle va
                      donner au moment de son coup et, idéalement encore, faire
                      déjà trois pas en avant lorsqu’on comprend qu’elle va
                      tenter un amorti. Enfin, troisièmement, on doit regarder
                      le court, ses limites et les espaces libres qu’il offre.
                    </p>
                    <p>
                      Lorsque l’on dit que Federer regarde la balle comme si
                      elle arrivait au ralenti - ce qui explique pourquoi il a
                      plus de temps que l’adversaire - on peut dire qu’Hingis
                      jouait à sa manière comme les grands régisseurs du
                      football: Zinédine Zidane, Michel Platini ou Thiago
                      Alcántara. Ils observaient le terrain avant de recevoir la
                      balle, ils savaient donc, avant de prendre le ballon,
                      comment l’action allait se poursuivre et ils l’envoyaient
                      dans des espaces libres que personne d’autre n’avait vus.
                      Ils avaient toujours un temps d’avance par rapport à
                      l’adversaire et sur le jeu. Et c’est pour cela que leurs
                      gestes semblaient si tranquilles, qu’ils donnaient cette
                      impression de facilité.
                    </p>
                    <p>
                      Exactement comme Hingis: elle était toujours juste sur la
                      balle, ses adversaires ne la surprenaient que rarement par
                      un contre-pied. D’une manière étrange, elle paraissait
                      savoir où les balles allaient arriver et où elle devait
                      les taper.
                    </p>
                    <p>Peut-on apprendre cela?</p>
                    <p>
                      Melanie Molitor: «Quand nous sommes arrivées en Suisse,
                      elle ne pouvait jouer que face à des adultes parce qu’ici,
                      il n’y avait quasiment pas d’enfants qui pratiquaient le
                      tennis. Et chez les adultes, c’est toujours la même chose:
                      ils ont tous un bon coup et un autre faible. Je disais
                      donc à Martina qu’elle devait éliminer le bon coup de son
                      adversaire. Dès que celle-ci ne pouvait plus utiliser son
                      arme, les désavantages physiques de Martina n’avaient plus
                      la moindre signification.»
                    </p>
                    <p>
                      Tout cela semble bien facile, mais ça ne l’est pas
                      lorsque, de l’autre côté du filet, on trouve Serena
                      Williams.
                    </p>
                    <p>
                      «Le coup droit de Serena était naturellement bien meilleur
                      que celui de Martina, répond Molitor. C’est pour cela que
                      nous essayions de faire en sorte que Serena ne se trouve
                      jamais en situation de pouvoir passer un bon coup droit.»
                    </p>
                    <p>«Et comment fait-on?»</p>
                    <p>
                      À cet instant de la discussion, Melanie Molitor nous donne
                      un cours de base du tennis: «Lorsque vous vous trouvez sur
                      la ligne de fond, vous pouvez prendre la balle de cinq
                      façons différentes. Imaginons que la balle, ayant atteint
                      son point culminant, commence de redescendre, vous devez
                      faire deux pas en arrière et vous ne pouvez alors que la
                      renvoyer très haut. Mais vous pouvez aussi rester à votre
                      place et soit l’envoyer haut, soit la jouer en demi-volée.
                      Vous pouvez encore faire deux pas en avant et prendre la
                      balle en volée topspin. Enfin, vous pouvez monter beaucoup
                      plus pour une volée slicée.»
                    </p>
                    <p>Elle nous toise sévèrement avant de continuer.</p>
                    <p>
                      «Vous avez donc cinq possibilités, mais vous ne les
                      maîtrisez pas toutes. Laquelle choisissez-vous? Vous devez
                      alors réfléchir et définir où vous désirez envoyer la
                      balle, qui est en face de vous – Serena Williams! – et
                      comment cette adversaire va pouvoir renvoyer la balle.
                      Vous devez en plus tenir compte du moment où cette action
                      survient dans le jeu. Au début, Serena Williams a
                      peut-être mieux joué son coup droit, maintenant elle est
                      un peu plus fatiguée, mais son coup droit reste sa
                      meilleure arme. Questions après questions. Et tout ce
                      processus – y compris la décision que vous avez prise -
                      doit se dérouler en quelques poussières de secondes.»
                    </p>
                    <p>
                      Ces questions, tous les joueurs, toutes les joueuses
                      amateurs se les posent. La singularité de Martina Hingis?
                      Elle était la plus capable, la plus rapide de toutes les
                      joueuses du circuit pour y répondre.
                    </p>
                    <p>Selon sa maman, sa deuxième force était la mentalité.</p>
                    <p>
                      «Martina était une joueuse totalement différente de moi.
                      J’étais «boulot, boulot», Martina, elle, jouait. Pour
                      elle, ce n’était jamais un problème de se décider pour une
                      demi-volée parmi les cinq possibilités. Je n’aurais jamais
                      joué la demi-volée, mais ma mission, comme entraîneur, ce
                      n’était pas qu’elle me ressemble. Au contraire, je voulais
                      tout faire pour qu’elle soit elle-même.»
                    </p>
                    <p>
                      Il est difficile de décrire ce petit jeu, ce sens de
                      l’inattendu, cet amour pour l’improvisation. Ou, plus
                      simplement, cette fantaisie. Une chose est certaine,
                      Martina en avait plus que toutes les autres.
                    </p>
                    <p>
                      Mais cela ne suffit pas d’être fantaisiste.
                      Paradoxalement, il faut pouvoir développer un immense
                      sérieux pour développer de telles idées. Et avoir courage
                      pour y croire, tout en n’oubliant jamais que vous pouvez
                      échouer. Tel est le prix du coup génial: un amorti qui
                      tourne mal, c’est une invitation offerte à l’adversaire
                      pour une attaque au filet. Un lob imprécis, un point perdu
                      assuré.
                    </p>
                    <p>
                      Dès lors, le jeu devient réellement le miroir de la vie:
                      celui qui n’essaie pas quelque chose de nouveau devient
                      vulnérable. Celui qui est rempli de fantaisie se découvre.
                      Celui qui ose gagne, tout en sachant qu’il peut aussi
                      échouer.
                    </p>
                  </div>
                </div>
              </Element>

              <Element className='section' name='section-6-3' id='section-6-3'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Chapitre 14</h6>
                    <h5>Chez la maman, à la table à manger</h5>
                    <p>
                      Longtemps, la carrière de Martina Hingis a été un projet
                      «mère-fille» auquel peu de gens avaient accès. «Je faisais
                      tout, raconte Melanie Molitor. Je donnais l’entraînement,
                      je lavais les habits, je m’occupais aussi des cordages des
                      raquettes, tout cela alors que nous étions déjà sur le
                      circuit professionnel. Je ne pouvais que difficilement
                      m’imaginer m’appuyer sur quelqu’un d’autre, je ne faisais
                      confiance à personne.»
                    </p>
                    <p>
                      Il n’est venu à l’esprit de personne de décrire Molitor et
                      Hingis comme des féministes, mais c’est exactement ce
                      qu’elles étaient: deux femmes qui s’étaient fait une place
                      dans un monde qui ne les attendait pas.
                    </p>
                    <p>
                      La structure du team va changer au milieu des années 90,
                      lorsque Molitor et Mario Widmer tombèrent amoureux. Né en
                      1940, Widmer était une des figures majeures du journalisme
                      sportif en Suisse, un héros doté d’une plume pertinente.
                      Il travaillait alors comme correspondant de «Blick» aux
                      États-Unis, avant de devenir responsable de la rédaction
                      sportive du quotidien zurichois. En 1997, il donne son
                      congé à son employeur, déménage à Regensdorf pour y vivre
                      avec maman et sa fille, et prendre en charge le management
                      d’Hingis.
                    </p>
                    <p>
                      Nous avons fait la connaissance de Mario Widmer un matin
                      du printemps 2021, lorsqu’avec Molitor, il nous a
                      accueillis à Schindellegi. Ils nous ont salués avec
                      courtoisie, mais à peine étions-nous assis autour de la
                      table à manger que nous avons ressenti qu’ils ne nous
                      faisaient pas confiance.
                    </p>
                    <p>
                      Ils connaissaient nos noms depuis les «protocoles de
                      Macolin», qui avaient été publiés six mois plus tôt dans
                      «Magazin» et «Le Matin Dimanche»; ils nous prenaient pour
                      des journalistes qui haïssaient le sport. Ils ne pouvaient
                      juste pas imaginer que nous traiterions Hingis avec
                      fair-play dans nos textes.
                    </p>
                    <SideElement side='right'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/6-3-mario-widmer.jpg'
                          : '../../images/6-3-mario-widmer.jpg')}
                      />
                      <figcaption>
                        Une équipe depuis 1997: Martina Hingis, Mario Widmer,
                        Melanie Molitor. Photo: Illustré/RDB/Ullstein Bild/Getty
                        Images
                      </figcaption>
                    </SideElement>
                    <p>
                      Nous avons passé deux heures avec eux pour leur expliquer.
                      À plusieurs reprises, nous avons craint que la discussion
                      ne s’arrête, ce qui nous rendait nerveux, parce que
                      réaliser un portrait d’Hingis sans avoir parlé à sa maman
                      était impensable. Cela n’aurait pas été un portrait
                      d’Hingis.
                    </p>
                    <p>
                      Ce qui ne nous aidait pas, à ce moment, c’est que Martina
                      Hingis elle-même était nerveuse avant notre rencontre avec
                      sa maman. Pourquoi? Pour mieux comprendre, il convient de
                      revenir quelque peu en arrière.
                    </p>
                    <p>
                      Au début, Martina Hingis était hésitante face à notre
                      volonté de parler avec sa mère. Et quand le rendez-vous
                      fut enfin fixé, elle ne voulait en aucun cas être
                      présente. Quelle était leur relation véritable?
                    </p>
                    <p>
                      Lors d’une de nos visites à Hingis dans son appartement de
                      Zoug, elle était en train de faire ses bagages.
                    </p>
                    <p>
                      «Vous voyagez?» (C’était au milieu de la troisième vague
                      de coronavirus).
                    </p>
                    <p>
                      «Non, répondit-elle, Harry suit un cours de
                      perfectionnement et je vais à la maison avec Lia.»
                    </p>
                    <p>À la maison, c’était chez sa maman, à Schindellegi.</p>
                    <p>
                      Et c’est probablement là que ressort le côté le «moins
                      suisse» d’Hingis: elle place la famille avant tout; pour
                      elle, une cohabitation étroite n’est pas étouffante. Au
                      contraire, c’est quelque chose de très beau.
                    </p>
                    <p>
                      «À l’Est, nous sommes beaucoup plus proches l’un de
                      l’autre, nous dit-elle. Pourquoi est-ce que les Suisses
                      envoient leurs parents dans des homes? Comment peut-on
                      vivre dans un appartement de quatre pièces pendant que les
                      vieux meurent seuls? Pourquoi laisse-t-on faire cela?»
                    </p>
                    <p>
                      Nous lui avons alors demandé pourquoi elle était si
                      nerveuse à l’idée que nous allions rencontrer sa maman.
                    </p>
                    <p>
                      «C’est à prendre ou à laisser, soit on vous comprend, soit
                      on ne vous comprend pas. Soit on se débrouille avec vous,
                      soit pas. Et je me fais un petit peu de souci, j’aimerais
                      savoir comme ils vont vous trouver.»
                    </p>
                    <p>
                      Cette discussion nous est revenue à l’esprit alors que la
                      maman, les bras croisés, le dos légèrement courbé, a posé
                      sur nous un regard sceptique.
                    </p>
                    <p>
                      Puis, après une courte pause, elle nous dit soudainement:
                      «Alors, que voulez-vous savoir?»
                    </p>
                    <p>
                      Ce qui suit est l'une des interviews les plus
                      intéressantes et les plus ouvertes que nous n'ayons jamais
                      menées. Lorsque nous avons quitté Melanie Molitor et Mario
                      Widmer, il était déjà fort tard dans l’après-midi.{' '}
                    </p>
                    <p>
                      (Pour une meilleure compréhension: toutes les citations de
                      Melanie Molitor qui figurent dans ce texte proviennent de
                      cette discussion. C’est également le cas pour les
                      chapitres précédents).
                    </p>
                    <p>
                      Pour Melanie Molitor et Mario Widmer, il devenait toujours
                      plus évident, au fil de la discussion, que tout n’avait
                      jamais été évident. Durant les années de la vie publique
                      de Martina, ils ont naturellement commis des erreurs. Ils
                      sont d’ailleurs les derniers à ne pas les reconnaître.
                      Quoi qu’ils fassent, comme beaucoup de parents, ils ont
                      suivi deux buts ambitieux et contradictoires: ils
                      voulaient protéger Martina Hingis, mais aussi qu’elle se
                      détermine elle-même.
                    </p>
                    <p>
                      Molitor: «J’estimais qu’elle devait assumer le plus
                      possible de responsabilités au quotidien, ce qui lui
                      permettrait ensuite de prendre des décisions intelligentes
                      sur le court, malgré la pression, malgré le public.
                      Malheureusement, quelques fois, elle a dit en public des
                      choses qu’elle aurait mieux fait de taire.»
                    </p>
                    <p>
                      Nous nous rappelons alors comment Melanie Molitor
                      décrivait son père, le grand-papa de Martina: quelqu’un
                      d’autonome, de rectiligne, qui aimait la liberté.
                      Quelqu’un qui ne se laissait pas intimider, qui
                      n’acceptait pas les ordres. Loin de nous l’idée de tomber
                      dans la psychologie de comptoir, mais n’est-ce pas là la
                      manière de jouer de Martina Hingis: libre, difficile à
                      contrôler, autonome?
                    </p>
                    <p>
                      Lorsque Mario Widmer a rejoint Molitor et Hingis, il était
                      reconnu comme le grand spécialiste du football, certains
                      affirmaient même qu’il pouvait dicter les formations aux
                      entraîneurs de l’équipe de Suisse. Il connaissait aussi
                      très bien la boxe, il était ami avec Muhammad Ali. En
                      revanche, le monde du tennis lui était étranger. Il fut
                      étonné par l’ambiance pesante qui régnait dans les salles
                      de petit-déjeuner des hôtels des joueuses, étonné de
                      mesurer le stress dans lequel vivaient les meilleures du
                      monde lorsque, d’une semaine à l’autre, quelque part
                      autour du globe, elles participaient à un nouveau tournoi;
                      donc à de nouveaux rendez-vous avec les médias, avec les
                      sponsors, avec les fans. Tout cela durant une saison qui
                      s’étalait sur onze mois.
                    </p>
                    <p>
                      En 2021, la superstar du tennis Naomi Osaka a rendu
                      publique la pression qui pesait sur ses épaules,
                      l‘obligation de terminer chaque journée de tournoi par une
                      conférence de presse; elle annula d’abord tous ses
                      rendez-vous avec les médias, avant de renoncer à plusieurs
                      tournois. Elle a alors dû faire face à des moqueries mais
                      a aussi suscité de l’admiration. Plusieurs sportifs et
                      sportives l’ont remerciée d’avoir eu le courage de parler
                      ouvertement de dépression, de pression populaire et
                      d’obligations de performances si lourdes qu’elles en
                      deviennent malsaines; ses collègues l’ont surtout
                      remerciée de ne pas avoir attendu la fin de sa carrière
                      pour en parler.
                    </p>
                    <p>
                      Tout était différent à la fin des années 90. Il était rare
                      de rencontrer un encadrement psychologique autour d’un
                      sportif. La santé mentale n’était pas un thème. Et encore
                      beaucoup plus qu’aujourd’hui, les gens pensaient: celui
                      qui gagne autant d’argent peut bien supporter quelques
                      contrariétés.
                    </p>
                    <p>
                      Mario Widmer commença alors à comprendre pourquoi il était
                      si important pour Melanie Molitor d’ériger un mur autour
                      de sa famille. Une fois l’entraînement terminé, le
                      quotidien ne devait pas être compliqué.
                    </p>
                    <p>
                      Ils appelaient cela leur petite île. Quand, pour préparer
                      les tournois aux États-Unis, il fallait passer quelques
                      semaines à Tampa, en Floride, où elle possédait une
                      maison, le programme quotidien était le suivant: le matin,
                      la maman et la fille s’entraînaient, Mario Widmer faisait
                      les achats et cuisinait. Puis Molitor faisait la
                      vaisselle, Hingis s’allongeait et Widmer partait au golf.
                    </p>
                    <p>
                      «C’était quelque chose de postcommuniste, raconte Molitor
                      en souriant. Vous voyez, en Suisse, il est souvent
                      important de regarder à l’extérieur, de savoir ce que les
                      autres pensent de toi. Chez nous, en Tchécoslovaquie,
                      l’important était toujours ce qui est en toi, ce que l’on
                      retient l’un de l’autre.»
                    </p>
                    <p>
                      À Trübbach, lorsque Widmer ne faisait pas encore partie de
                      l’équipe, plus tard aussi à Regensdorf, il y avait parfois
                      dix, quinze personnes autour de la table à manger, des
                      joueuses, des entraîneurs, des parents. «Nous avions
                      fréquemment de la compagnie, dit Molitor. Je voulais que
                      Martina ait toujours les bonnes personnes autour d’elle.»
                      Les sœurs Williams, Jennifer Capriati, Monica Seles, Anna
                      Kournikova, toutes, au fil des ans, au gré d’un
                      entraînement commun, sont venues en visite en Suisse.
                    </p>
                    <p>
                      Aujourd’hui, à Schindellegi, Melanie Molitor confie:
                      «Quand nous étions nouveaux sur le circuit, les bonnes
                      joueuses n’étaient pas si sympas avec Martina. Je lui
                      disais alors: «Si un jour tu es bonne, tu ne devras pas te
                      comporter ainsi.» Quand Martina est devenue numéro 1, la
                      tendance a changé parmi les meilleures, l’acceptation
                      était d’une certaine manière plus relax.» Elle raconte
                      cela avec de la chaleur dans la voix, comme si, pour elle,
                      ce changement de comportement avait été plus important que
                      les victoires.
                    </p>
                    <p>
                      Molitor n’a pas seulement amené sa fille à la première
                      place mondiale, elle a aussi permis à Belinda Bencic
                      d’entrer dans le top 10. Aujourd’hui, elle conseille
                      l’Allemande Julia Stusek, qui vient d’être sacrée
                      championne d’Europe juniors. L’image que se fait le public
                      suisse de l’entraîneur Melanie Molitor est diamétralement
                      opposée à sa réputation dans le milieu: Melanie Molitor
                      n’est pas une «mamie du tennis» obstinée, elle en est
                      l’une des meilleures entraîneuses au monde.
                    </p>
                    <p>
                      Mais d’où vient l’image que l’on se forge d’une personne?
                      Il semble clair qu’elle ne naît pas de rien. La façon
                      d’être de Molitor, ancrée dans ses racines
                      tchécoslovaques, peut paraître cassante par rapport à
                      l’amabilité helvétique. Elle est également une personne
                      sceptique, une entraîneuse exigeante, elle était une maman
                      qui demandait beaucoup à sa fille. Mais exigeait-elle plus
                      que Pauli Gut de sa fille Lara? Plus que Fritz Weyermann
                      d’Anita? Ou que Markus Neff de Jolanda?
                    </p>
                    <SideElement side='left'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/6-4-mutter.jpg'
                          : '../../images/6-4-mutter.jpg')}
                      />
                      <figcaption>
                        «J'étais d'avis qu'elle devait assumer le plus de
                        responsabilités possible»: la mère à propos de sa fille.
                        Photo: Jürgen Hasenkopf
                      </figcaption>
                    </SideElement>
                    <p>D’où vient alors cette antipathie pour la maman?</p>
                    <p>
                      Peut-être du fait, justement, qu’elle est la maman et pas
                      le papa.
                    </p>
                    <p>
                      L’image de la mère incarnée par Molitor est un contraste
                      absolu de l’idéal suisse de la maman dévouée, prévenante,
                      chaleureuse, mais finalement discrète. Une maman dont la
                      vie se limite à la sphère privée, une maman importante
                      pour la famille, mais insignifiante sur le plan
                      individuel. On accepte les ambitions du père, pour lui et
                      pour les autres. Le père se consacre au vaste monde, à sa
                      propre personnalité, à ses attentes.
                    </p>
                    <p>
                      Selon cette version, Melanie Molitor passe pour la femme
                      inconvenante qui a laissé son mari pour se réaliser au
                      travers de sa fille, plutôt que d’assumer le rôle qui
                      devait être le sien. Et pour les femmes, la réprobation de
                      Molitor exprime peut-être aussi une certaine frustration,
                      parce qu’elle a pris totalement sa vie en main, ce que ne
                      faisaient alors que très peu de Suissesses.
                    </p>
                  </div>
                </div>
              </Element>

              <Element className='section' name='section-6-4' id='section-6-4'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Chapitre 15</h6>
                    <h5>Quand le tennis féminin éclipse le tennis masculin</h5>
                    <p>
                      Entre 1999 et 2001, quelque chose d’unique s’est produit:
                      le tennis féminin est passé devant le tennis masculin au
                      classement du «spectacle». «Aujourd’hui, ose Monica Seles
                      juste avant l’US Open 2001, les hommes sont vraiment
                      ennuyeux.»
                    </p>
                    <p>
                      Chez les hommes, Marat Safin, Gustavo Kuerten et Lleyton
                      Hewitt jouaient au sommet. Tous étaient, bien sûr, de bons
                      joueurs, mais ils paraissaient ternes en comparaison
                      d’Anna Kournikova, de Lindsay Davenport, de Monica Seles,
                      des sœurs Williams, de Martina Hingis ou de Jennifer
                      Capriati. Et, régulièrement, de nouvelles jeunes joueuses
                      apparaissaient, comme Kim Clijsters ou Justine Henin.
                      Jamais encore on n’avait vu autant de championnes
                      talentueuses, ambitieuses, truculentes, mais également
                      rebelles et différentes, dans le top 10 mondial. Le «New
                      York Magazine» utilisait le terme «Riot Girls» pour parler
                      de ces rivales qui se livraient des duels homériques et
                      qui, le match terminé, faisaient la fête ensemble.
                    </p>
                    <p>
                      C’était aussi la période où la WTA a tenté de faire de ses
                      joueuses... plus que de simples joueuses. Il y avait des
                      réceptions, des soirées de gala; les jeunes femmes ne
                      devaient pas seulement jouer, elles devaient soigner leur
                      apparence, être sexys, se montrer habiles dans la
                      conversation et, mieux encore, ne pas hésiter à provoquer.
                      Elles devaient consacrer du temps aux shootings photos,
                      aux rendez-vous avec les sponsors et autres obligations
                      publiques.
                    </p>
                    <p>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/6-5-spielerinnen.jpg'
                          : '../../images/6-5-spielerinnen.jpg')}
                      />
                      <figcaption>
                        Une partie des «Riot Girls» (de gauche à droite): Venus
                        Williams, Patty Schnyder, Jana Novotná, Martina Hingis,
                        Lindsay Davenport Davenport, Nathalie Tauziat, Arantxa
                        Sánchez Vicario, Natallja Swerawa. Photo: Jürgen
                        Hasenkopf (Imago)
                      </figcaption>
                    </p>
                    <p>
                      Cet ensemble a permis au tennis de devenir plus lucratif.
                      Le «prize money» de l’US Open est ainsi passé de 6,4
                      millions de dollars en 1990 à 15 millions de dollars en
                      2000. Corollaire, les attentes étaient toujours plus
                      grandes, l’attention et la pression également. Les
                      meilleures joueuses, que tout le monde observait,
                      mitraillaient leurs concurrentes quand elles se
                      retrouvaient opposées en conférence de presse, des
                      querelles que les journalistes entretenaient avec
                      délectation. Les méchants n’étaient plus seulement John
                      McEnroe et Jimmy Connors, ces «bad boys» qui étalaient
                      leurs bagarres sur et hors des courts; désormais, les
                      femmes rivalisaient également avec les hommes dans ce
                      domaine.
                    </p>
                    <p>
                      C’est dans ce contexte qu’Hingis s’est permis des
                      déclarations qui, aujourd’hui encore, la travaillent et
                      dont elle préférerait ne plus jamais parler. Par exemple,
                      cette remarque lancée à la joueuse française lesbienne
                      Amélie Mauresmo: «Une moitié d’homme.» Ou encore que les
                      sœurs Williams avaient, selon elle, un avantage dans les
                      opérations de marketing car elles étaient Noires.
                    </p>
                    <SideElement side='left'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/6-6-anna-kournikova.jpg'
                          : '../../images/6-6-anna-kournikova.jpg')}
                      />
                      <figcaption>
                        Adversaire, partenaire de double et amie: la diva du
                        tennis russe Anna Kurnikova. Photo: Greg Wood (AFP/Getty
                        Images)
                      </figcaption>
                    </SideElement>
                    <p>
                      Son altercation avec la diva russe du tennis Anna
                      Kournikova en 2000, à Santiago de Chile, est ainsi devenue
                      légendaire.
                    </p>
                    <p>
                      Quelques semaines plus tôt, les deux avaient remporté
                      ensemble la finale WTA en double et voilà qu’elles se
                      retrouvaient opposées en simple dans un tournoi exhibition
                      sans importance. Après une décision erronée à propos d’une
                      balle qui avait terminé sur la ligne, toutes les deux ont
                      commencé à se chambrer et, lors du changement de côté
                      suivant, Hingis aurait dit à Kournikova: «Tu crois que tu
                      es la reine? JE SUIS LA REINE!»
                    </p>
                    <p>
                      Dans le vestiaire, les trophées ont volé. Par la suite,
                      Hingis a changé de partenaire de double, préférant Seles à
                      Kournikova. Mais une année plus tard, à l’US Open, les
                      deux jeunes femmes évoluaient à nouveau ensemble.
                    </p>
                    <p>
                      En fait, ce n’était qu’un jeu. Au contraire des hommes,
                      les femmes savent rire de leurs querelles. Quand elle
                      regarde dans le rétroviseur, Hingis parle d’une époque
                      «cool».
                    </p>
                    <p>
                      Quelques mois plus tard, quand nous avons à nouveau
                      rencontré Hingis et que nous nous comportions comme de
                      vieux amis, elle nous a dévoilé ce qu’elle avait appris à
                      propos des hommes pendant sa carrière. Des différents
                      sujets dont elle nous a parlé, c’est certainement le plus
                      remarquable.
                    </p>
                  </div>
                </div>
              </Element>
            </div>

            <div className='ui vertical segment' style={{ padding: '0' }}>
              <Element className='section' name='section-7' id='section-7'>
                <SegmentHeader
                  part='Cinquième partie'
                  title='Misères et bonheur'
                  image={require(isMobile
                    ? '../../images/7-martina.jpg'
                    : '../../images/7-martina-desktop.jpg')}
                  caption='Photo: Cyrill Matter'
                />
              </Element>

              <Element className='section' name='section-7-1' id='section-7-1'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Chapitre 16</h6>
                    <h5>Histoires de relations</h5>
                    <p>
                      Martina Hingis est devenue adulte sur le circuit. Ce que
                      d’autres découvrent dans les camps de ski ou dans les
                      voyages scolaires, elle l’a appris avec le statut de
                      personnage public. Chaque flirt, chaque baiser, chaque
                      relation était scruté avec avidité par la presse de
                      boulevard. Deux fois fiancée, une fois même mariée. Elle
                      fréquentait des joueurs de tennis, des professionnels du
                      golf, des stars du football.
                    </p>
                    <p>
                      «Quand on est une sportive, on ne fait connaissance
                      presque qu’avec des sportifs, dit-elle en haussant les
                      épaules. Beaucoup sont des fans de tennis, ils viennent
                      aux tournois du Grand Chelem, ils ont un badge et traînent
                      là autour. Mais c’est difficile. Il y a d’abord le
                      problème du programme. On constate rapidement que chacun
                      suit son propre calendrier et, sans que l’on ne s’en
                      aperçoive, une demi-année passe et les sentiments
                      disparaissent.»
                    </p>
                    <p>
                      Hingis parle ouvertement du problème numéro 2: «Pour avoir
                      du succès en sport, on a besoin d’un ego très développé.
                      Comme on se concentre sur soi-même tout le temps, il nous
                      est difficile de faire des compromis. Lorsque deux ego se
                      rencontrent, c’est d’abord intéressant. On fonctionne de
                      la même façon et l’on se dit: «Il me comprend.» Puis on
                      remarque que rien ne peut se passer entre deux personnes
                      de ce type, car chacune ne pense qu’à elle.»
                    </p>
                    <SideElement side='left'>
                      <div className='quote-element'>
                        <p className='quote'>
                          «Les hommes ne veulent pas être «le copain d’Hingis». Ils veulent le contraire»
                          <div className='person'>Martina Hingis</div>
                        </p>
                      </div>
                    </SideElement>
                    <p>
                      Elle nous parle alors de cette difficulté particulière,
                      que d’autres femmes célèbres vivent aussi en dehors du
                      sport: «Avec Sergio – le joueur de golf professionnel
                      Sergio Garcia, avec lequel Hingis était liée jusqu’en 2002
                      – nous étions toujours comparés l’un à l’autre. Et
                      j’étais, cela paraît idiot aujourd’hui, plus avancée que
                      lui. Au début, il était fasciné, mais avec le temps, ça
                      l’a dérangé de constater que son amie était un numéro plus
                      grand que lui.»
                    </p>
                    <p>«C’était souvent ainsi?» demandons-nous.</p>
                    <p>«Oui, malheureusement.»</p>
                    <p>«Vous étiez toujours le plus grand numéro?»</p>
                    <p>
                      «Oui, et c’est pour cela que l’ego des hommes souffrait.
                      Les hommes ne veulent pas être «le copain d’Hingis». Ils
                      veulent le contraire. C’est seulement quand ils deviennent
                      plus âgés qu’ils apprennent à être au-dessus de cela.»
                    </p>
                    <p>
                      En 2016, Martina Hingis a rencontré Harald Leemann, un
                      médecin du sport de Zoug, avec qui elle vit toujours
                      aujourd’hui. «C’était complètement différent. Il se
                      réjouit quand ça va bien pour moi, il n’y a pas de
                      concurrence entre nous.» Elle boit une gorgée d’eau
                      minérale: «Probablement parce que chacun a son propre
                      métier. Je crois que c’est important en amour.»
                    </p>
                  </div>
                </div>
              </Element>

              <Element className='section' name='section-7-2' id='section-7-2'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Chapitre 17</h6>
                    <h5>La plus belle période</h5>
                    <p>
                      Lorsqu’on demande à Martina Hingis à quel moment de sa
                      carrière elle était le plus heureuse, elle ne répond pas:
                      son premier succès dans un tournoi pro, ses victoires en
                      Grand Chelem ou le jour où elle est devenue la plus jeune
                      numéro 1 du classement mondial de l’histoire? Non. Elle
                      dit: «Le plus beau, c’était en double.»
                    </p>
                    <p>
                      Les matches avec deux joueurs, joueuses de chaque côté du
                      filet ne sont que rarement retransmis à la télévision, les
                      primes sont faibles, les véritables spécialistes de double
                      ne sont en général pas connus. Ce qui est dommage.
                    </p>
                    <p>
                      Parce que le double, spécialement le double féminin, est
                      une discipline sous-estimée: rapide, distrayante et
                      dépendant beaucoup moins qu’en simple de la seule force
                      physique. Ceux et celles qui gagnent dans cet exercice
                      sont ceux et celles qui allient technique, tactique et
                      jouerie. En d’autres mots, c’est une discipline parfaite
                      pour Martina Hingis.
                    </p>
                    <SideElement side='right'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/7-1-olympia.jpg'
                          : '../../images/7-1-olympia.jpg')}
                      />
                      <figcaption>
                        Chance tardive: argent olympique en double avec Timea
                        Bacsinszky 2016 à Rio de Janeiro. Photo: Claude Diderich
                        (Freshfocus)
                      </figcaption>
                    </SideElement>
                    <p>
                      Hingis est arrivée sur le tour professionnel à l’époque où
                      la plupart des joueuses de simple s’alignaient également
                      en double. Martina Navratilova, Jana Novotna, Arantxa
                      Sánchez Vicario, Lindsay Davenport, toutes n’étaient pas
                      seulement parmi les meilleures en simple, elles étaient
                      aussi numéro 1 au classement mondial du double.
                    </p>
                    <p>
                      Hingis appartenait à ce cénacle. Pendant une incroyable
                      période qui couvre deux décennies – entre 1998 et 2018 –
                      elle a occupé la place de numéro 1 pendant 91 semaines,
                      soit presque deux ans. Elle a gagné treize titres du Grand
                      Chelem en double et sept autres en double mixte, une
                      spécialité encore moins connue où chaque équipe est formée
                      d’un homme et d’une femme.
                    </p>
                    <p>
                      Mais la popularité n’était pas ce que Martina Hingis
                      recherchait. Les victoires, oui – avec elle, ce fut
                      toujours le cas - mais il y avait autre chose. Un des
                      aspects les plus importants de sa carrière, même si elle
                      ne trouve que difficilement les mots pour en parler.
                    </p>
                    <p>
                      Avec le temps, nous avons fini par comprendre. Martina
                      Hingis jouait les doubles pour ne pas avoir uniquement des
                      adversaires, mais aussi, parfois, des partenaires – si
                      possible, même, des amis – avec qui elle pouvait voyager,
                      s’entraîner, partager un but commun.
                    </p>
                    <p>
                      À Schindellegi, Mario Widmer nous parle d’éléments dont
                      nous n’avons pas conscience: combien la vie d’un joueur,
                      d’une joueuse de tennis professionnel est solitaire.
                      Chaque semaine, ils se retrouvent dans un autre endroit,
                      mais toujours sous la même cloche. Les jours se
                      ressemblent, on passe d’un match à l’autre, on se couche
                      tôt, on cherche la joie sur le court. Un rythme qui ne
                      laisse pas de place pour ce qui compte finalement le plus
                      dans une vie: les amitiés. Monica Seles le confirme, quand
                      elle rappelle qu’elle n’a pu développer une vraie amitié
                      avec Hingis qu’après sa carrière.
                    </p>
                    <p>
                      C’est presque incroyable, mais les 64 tournois de double
                      remportés par Martina Hingis l’ont été avec dix-sept
                      joueuses différentes. Certains répètent que ces nombreux
                      changements avaient un rapport direct avec le côté
                      lunatique d’Hingis, spécialement lorsque, en 1998, elle se
                      sépara de Jana Novotna en prétextant que la joueuse
                      tchèque était devenue «vieille et lente». Mais on peut
                      tout aussi bien analyser le fait que Martina Hingis ait
                      connu le succès avec autant de partenaires par deux
                      raisons totalement autres.
                    </p>
                    <p>
                      Premièrement, elle a été très longtemps sur le circuit,
                      plus longtemps que presque toutes les autres. Après ses
                      débuts en 1994 et sa première retraite en 2003, elle est
                      revenue en 2006 pour remporter trois tournois
                      supplémentaires en simple et remonter une fois encore au
                      sixième rang de la hiérarchie mondiale. En 2007, elle a
                      annoncé une deuxième fois sa retraite. En 2013, elle est
                      revenue en renonçant à jouer en simple, alors qu’en
                      double, elle a connu la plus belle période de sa carrière.
                    </p>
                    <p>
                      Le fait de réussir à former avec autant de partenaires
                      différentes une équipe qui fonctionnait met un autre
                      élément en lumière: le fait qu’elle dispose d’une capacité
                      rare parmi les sportives individuelles. Elle est non
                      seulement capable de s’améliorer elle-même mais permet
                      aussi à sa partenaire de progresser.
                    </p>
                    <p>
                      En parlant avec l’Allemande Sabine Lisicki, finaliste de
                      Wimbledon en 2011 et peut-être la plus grande supportrice
                      vivante d’Hingis, cette impression se confirme.
                    </p>
                    <p>
                      Le parcours de Lisicki présente plusieurs similitudes avec
                      celui d’Hingis: elle était entraînée par son père, un
                      immigrant polonais. À ses débuts, l’argent de la famille
                      était si limité qu’elle ne pouvait s’offrir que très
                      rarement l’accès à des tournois à l’étranger. Et elle a
                      aussi subi l’incompréhension dans sa patrie, l’Allemagne,
                      parce qu’avec son père, ils n’étaient pas de ceux «qui
                      sautent devant chaque caméra», comme elle le dit
                      elle-même.
                    </p>
                    <p>
                      Après une année de défaites et de blessures, elle s’est
                      approchée d’Hingis pour savoir si cette dernière pouvait
                      l’aider. Le fait de contacter la Suissesse au moment le
                      plus difficile de sa carrière a, une fois encore, un
                      rapport avec Melanie Molitor.
                    </p>
                    <p>
                      Lisicki avait 10 ans lorsqu’une agence de marketing
                      sportif l’envoya chez Melanie Molitor pour qu’elle
                      s’occupe d’elle.
                    </p>
                    <p>
                      Au téléphone depuis Bradenton, en Floride, où elle vit
                      désormais, elle nous raconte: «Nous étions parfois là
                      trois ou quatre jours. Pour moi, c’était une expérience
                      incroyable de pouvoir dormir chez elle, dans sa maison.
                      Comme Martina était loin, je pouvais même utiliser sa
                      chambre. À l’époque, nous n’avions pas d’argent, je
                      n’avais pas encore de sponsors et un tee-shirt de match
                      coûtait 70 euros! Un jour, Melanie Molitor m’a donné un
                      sac avec des habits de Martina. De ma vie, je n’avais
                      encore jamais vu autant de vêtements.»
                    </p>
                    <p>
                      Melanie Molitor ne voyait pas seulement le talent de
                      Lisicki, elle avait aussi compris qu’il y avait une
                      famille à soutenir.
                    </p>
                    <p>
                      «Il n’existe pas de mots pour dire combien elle nous a
                      alors - et plus tard encore - aidés. Je considérerai
                      toujours Melanie Molitor comme une immense personne. Je
                      lui dois une grande partie de ma carrière.»
                    </p>
                    <p>
                      Quatorze ans plus tard, lorsqu’elle se retrouve à nouveau
                      dans une période difficile, c’est vers la fille de Molitor
                      qu’elle s’est tournée, lui demandant de devenir son
                      entraîneur.
                    </p>
                    <p>
                      «Ce qui m’a toujours fascinée, c’était comment Martina
                      réussissait à détruire tactiquement ses adversaires, nous
                      explique-t-elle. Face à elle, le court devenait immense,
                      elle jouait avec les coins, elle réussissait des amortis,
                      des lobs, elle maîtrisait complètement tous les coups du
                      tennis. Et elle avait toujours du plaisir. C’est
                      exactement ce que je voulais retrouver.»
                    </p>
                    <p>
                      Peu après le début de leur collaboration, Lisicki a
                      remarqué qu’Hingis était toujours, dans l’âme, plus
                      joueuse qu’entraîneur. C’est pourquoi elle lui a demandé:
                      « Peux-tu imaginer jouer en double avec moi?»
                    </p>
                    <p>
                      «Pourquoi pas?, répondit alors Hingis. Nous devrions juste
                      essayer de nous entraîner quelques fois.»
                    </p>
                  </div>
                </div>
              </Element>

              <Element className='section' name='section-7-3' id='section-7-3'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Chapitre 18</h6>
                    <h5>
                    Une affaire de dopage ridicule avec des conséquences scandaleuses
                    </h5>
                    <p>
                      Lorsqu’un sportif ou une sportive suisse veut mesurer sa
                      popularité, il dispose d’un indicateur très sûr: les
                      Mérites sportifs.
                    </p>
                    <p>
                      Depuis 1950, peu avant Noël, les athlètes helvétiques sont
                      honorés. Mais ce ne sont pas toujours les meilleurs qui
                      sont récompensés, pas toujours ceux qui connaissent le
                      plus de succès. Ce sont les plus populaires. Parce que le
                      classement n’est pas établi par un jury de spécialistes,
                      mais par un cercle qui s’est élargi au fil des années.
                      Pour commencer, c’était les journalistes sportifs qui
                      avaient la parole. Puis, dès 1999, le public de la
                      télévision. Depuis 2006, un tiers des suffrages est
                      réservé aux sportives et aux sportifs eux-mêmes.
                    </p>
                    <p>
                      À la lecture des palmarès, on se rend bien compte quelles
                      sont les disciplines sportives les plus considérées du
                      pays: on les trouve soit sur la neige (ski, ski de fond),
                      soit parmi des disciplines où apparaît nettement l’effort
                      (l’athlétisme, le triathlon, le cyclisme). Les sportives
                      qui ont été le plus grand nombre de fois récompensées sont
                      la skieuse Vreni Schneider (cinq fois), la gymnaste
                      Ariella Kaeslin, la spécialiste de courses d’orientation
                      Simone Niggli-Luder et la skieuse Lise-Marie Morerod
                      (chacune trois fois).
                    </p>
                    <p>
                      Logiquement, vous allez demander combien de fois Martina
                      Hingis a gagné.
                    </p>
                    <p>Une seule.</p>
                    <p>
                      C’était lors de sa folle année 1997, lorsqu’elle remporta
                      75 de ses 80 matches, lorsqu’elle devint la plus jeune
                      joueuse de tennis de l’histoire classée numéro 1 mondiale.
                      Peu après, elle était élue «sportive de l’année» au niveau
                      planétaire, une première pour le sport helvétique.
                    </p>
                    <p>
                      Et encore, la Suisse a failli lui refuser cet honneur,
                      puisqu’elle ne l’avait remporté que de justesse face à la
                      Bernoise Anita Weyermann, «l’athlète qui court et ne pense
                      pas», comme certains la décrivaient alors; cette année-là,
                      elle avait remporté le bronze sur 1500 mètres lors des
                      championnats du monde.
                    </p>
                    <p>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/7-2-wimbledon_1997.jpg'
                          : '../../images/7-2-wimbledon_1997.jpg')}
                      />
                      <figcaption>
                        La reine de Wimbledon: après avoir remporté la finale
                        contre Jana Novotná en 1997. Photo: Elise Amendola
                        (Keystone/AP Photo)
                      </figcaption>
                    </p>
                    <p>
                      En 1998, la distinction est revenue à la triathlète
                      Natascha Badmann. Hingis ne figurait qu’au quatrième rang
                      du classement, devancée encore par la spécialiste de
                      marathon Franziska Rochat-Moser et par Weyermann,
                      deuxième. Avait-elle connu une mauvaise saison? Pas du
                      tout, elle avait remporté l’Open d’Australie en simple et
                      réussi le Grand Chelem en double.
                    </p>
                    <p>
                      Et en 1999, alors que pour la première fois, le public de
                      la télévision participait au vote?
                    </p>
                    <SideElement side='left'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/7-3-australien_1997.jpg'
                          : '../../images/7-3-australien_1997-desktop.jpg')}
                      />
                      <figcaption>
                        Son tournoi préféré: Martina Hingis remporte trois fois
                        l'Open d'Australie. Photo: Elise Amendola (Keystone/AP
                        Photo)
                      </figcaption>
                    </SideElement>
                    <p>
                      En 1999, Hingis fut éliminée dès le premier tour à
                      Wimbledon, avant la fameuse finale de Paris face à Steffi
                      Graf. Parfois, elle déchargeait sa frustration née de ses
                      difficultés face au «nouveau tennis» de fond de court par
                      des attaques méprisantes à l’encontre de ses adversaires.
                      Malgré tout, cela n’était pas une mauvaise saison
                      puisqu’elle a remporté pour la troisième fois d’affilée
                      l’Open d’Australie et repris la tête du classement
                      mondial. Elle était donc – il faut le souligner encore une
                      fois – la meilleure du monde dans une discipline sportive
                      planétaire. Aucune Suissesse, d’aucune autre discipline,
                      ne pouvait être comparée – même de loin – avec elle.
                    </p>
                    <p>
                      Lors de ces Sports Awards (les Mérites sportifs)
                      retransmis en direct depuis le Kursaal, à Berne, la
                      nageuse Flavia Rigamonti et, une fois encore, l’athlète
                      Anita Weyermann étaient les autres «nominées». Hingis
                      n’était pas présente à l’événement, elle était en Floride
                      où elle préparait la nouvelle saison. La télévision
                      voulait l’avoir en direct, tout était prévu. Mais Mario
                      Widmer, le partenaire de Melanie Molitor et le manager
                      d’Hingis, fit savoir que Martina ne serait à disposition
                      pour une interview qu’en cas de victoire.
                    </p>
                    <p>
                      L’animateur de la soirée proclama cela devant la caméra.
                      La réponse du public allait être claire: il choisit
                      Weyermann, dont le plus grand succès, cette année-là,
                      était un titre européen en cross.
                    </p>
                    <p>
                      Chef des sports à la Télévision suisse, Urs Leutert dira
                      plus tard: «Le comportement de Martina n’était qu’une
                      surenchère de cynisme absolu. Elle a montré en direct
                      combien elle méprisait le public suisse et les fans dans
                      notre pays.»
                    </p>
                    <p>
                      D’autres journalistes ont semblé personnellement offensés.
                      Le «Blick» lança rapidement un micro-trottoir qui a montré
                      combien l’opinion publique était furieuse. La tendance par
                      rapport à Hingis venait de basculer définitivement:
                      désormais, elle n’était plus qu’une mauvaise perdante.
                    </p>
                    <p>
                      Et c’était peut-être vrai. Car tous les athlètes sont
                      mauvais perdants. S’ils ne l’étaient pas, ils ne seraient
                      pas aussi performants. «Alors que Federer laisse rebondir
                      avec grandeur et flegme les critiques qui lui sont
                      adressées, Hingis se mettait en boule et était vexée»: la
                      «NZZ» écrivait encore cela au moment de sa retraite
                      définitive, presque deux décennies plus tard.
                    </p>
                    <SideElement side='right'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/7-4-autogramme_1996.jpg'
                          : '../../images/7-4-autogramme_1996-desktop.jpg')}
                      />
                      <figcaption>
                        La première femme suisse à être connue dans le monde
                        entier: Hingis à Londres en 1997. Photo: Elise Amendola
                        (Keystone/AP Photo)
                      </figcaption>
                    </SideElement>
                    <p>
                      Le fait est que Federer avait réagi généreusement
                      lorsqu’il avait, une fois, perdu un vote de sympathie
                      (contre le pilote motocycliste bernois Tom Lüthi). Mais il
                      est facile de se montrer grand seigneur quand on n’est
                      jamais attaqué.
                    </p>
                    <p>
                      Au contraire, en 1999, Martina Hingis traînait déjà sa
                      réputation. Elle était – comme beaucoup d'immigrants et
                      d'immigrantes - exposée à un subtil scepticisme. Celui qui
                      vient de l’extérieur doit se justifier plus que les
                      autres. Pour ses fautes comme pour ses succès. On la
                      regardait d’un œil critique quand ça allait mal, mais
                      également quand tout allait bien.
                    </p>
                    <p>
                      Pour ceux qui n’ont jamais vécu de telles expériences, il
                      est difficile d’imaginer la réaction que peut avoir un
                      immigrant ou une immigrante face à un rejet ou une
                      non-reconnaissance.
                    </p>
                    <p>
                      Ce comportement, souvent interprété comme de la
                      «susceptibilité», montre en définitive comment une
                      expérience durable de discrimination laisse des traces.
                      Certains réagissent avec prudence et méfiance, d’autres se
                      fâchent. Ces deux réactions sont toutefois l’expression
                      d’une déception.
                    </p>
                    <p>
                      On pourrait évidemment affirmer que Martina Hingis aurait
                      pu tout ignorer. Elle gagnait des millions, elle était une
                      star dans le monde entier. Mais c’est ce qui est
                      intéressant: elle n’était pas indifférente, ça la
                      dérangeait. Elle voulait être reconnue en Suisse. Parce
                      que c’est le pays qu’elle aimait. C’était chez elle.
                    </p>
                    <p>
                      L’histoire va ensuite se répéter, les douleurs qui vont
                      avec aussi.
                    </p>
                    <p>
                      En raison de la pandémie de coronavirus, beaucoup
                      d’événements sportifs ont été annulés l’an dernier. Et la
                      Télévision suisse n’a pas organisé, en 2020, une cérémonie
                      des Mérites sportifs normale; à la place, l’idée a été de
                      désigner la meilleure sportive et le meilleur sportif
                      depuis le lancement de la manifestation, en 1950.
                    </p>
                    <p>
                      Et Martina Hingis, la sportive suisse qui a connu le plus
                      de succès de tous les temps, n’a même pas été nominée!
                    </p>
                    <p>
                      Tout cela est en lien avec un événement survenu treize ans
                      auparavant. En été 2007 – la deuxième saison après son
                      retour – Hingis s’est retrouvée une nouvelle fois à
                      Wimbledon. Elle savait, à ce moment-là, que le meilleur de
                      sa carrière en simple était derrière elle. Elle souffrait
                      de problèmes au dos et à la hanche, et cela suffisait de
                      moins en moins pour tenir les duels spectaculaires avec
                      les meilleures joueuses du monde. À Wimbledon, elle savait
                      qu’elle n’avait pas la moindre chance et fut éliminée dès
                      le troisième tour, face à une inconnue américaine.
                    </p>
                    <p>
                      Après la défaite, elle a dû passer par le contrôle
                      antidopage.
                    </p>
                    <p>
                      Dix semaines plus tard, on lui annonça avoir trouvé dans
                      ses urines des traces de benzoylecgonine.
                    </p>
                    <p>
                      Benzoylecgonine? C’est le produit métabolique de la
                      cocaïne.
                    </p>
                    <p>«Vous aviez fait la fête?» demanda-t-on à Hingis.</p>
                    <SideElement side='left'>
                      <VideoPlayer
                        mp4={require('../../videos/10-dopingverdacht-fr.mp4')}
                        posterImage={require('../../videos/10-dopingverdacht.jpg')}
                        caption="Lors d'une conférence de presse, Hingis nie l'accusation d'avoir consommé de la cocaïne. Source: <a href='https://www.srf.ch/play/tv/-/video/-?urn=urn:srf:video:68390643-3931-43bc-a9fc-4e62a449962f'>SRF «10 vor 10»</a>"
                      />
                    </SideElement>
                    <p>
                      «Je l’aurais dit, nous répondit-elle. J’étais toujours
                      ouverte. Si tel avait été le cas, j’aurais dit: «J’ai
                      passé une soirée sympa, j’ai voulu essayer une fois.
                      Super.» Mais on ne fait pas de telles choses la veille
                      d’un match à Wimbledon.»
                    </p>
                    <p>«Vous vouliez peut-être augmenter vos performances?»</p>
                    <p>
                      «Je ne sais pas si vous avez déjà une fois «sniffé» ni si
                      vous vous êtes déjà retrouvé sur un court de tennis, voire
                      les deux à la fois. Ce que je peux vous dire, c’est que la
                      dernière chose dont on a besoin, ce sont des drogues
                      récréatives.»
                    </p>
                    <p>
                      Ce qui s’est passé à Wimbledon a fait l’objet de
                      nombreuses spéculations. Mais on peut les résumer en cinq
                      points, qui ne font pas le moindre doute:
                    </p>
                    <ol>
                      <li>
                        Aussi faibles que pouvaient être les traces, le contrôle
                        était positif.
                      </li>
                      <li>
                        Une analyse des cheveux a montré qu’Hingis ne consommait
                        pas régulièrement de la cocaïne. Mais cela n’était pas
                        pour autant la preuve qu’elle n’avait rien pris la
                        veille de ce match.
                      </li>
                      <li>
                        Hingis a contesté cette accusation de consommation de
                        cocaïne et a présenté son dossier à la justice. (Elle
                        nous a dit: «J’ai peur des drogues. Je n’ai jamais fumé.
                        Je crois que les cigarettes sont dangereuses. J’ai
                        peut-être tiré une fois ou l’autre une bouffée de
                        cigare.»
                      </li>
                      <li>Elle a été suspendue pendant deux ans.</li>
                      <li>
                        En 2019, l’AMA (Agence mondiale antidopage) a décidé que
                        les drogues récréatives comme l’héroïne, le cannabis,
                        l’ecstasy et la cocaïne ne pouvaient plus être
                        considérées comme des produits qui améliorent les
                        performances. Un test positif à l’un de ces produits est
                        désormais puni d’une suspension de trois mois.
                      </li>
                    </ol>
                    <p>
                      Pour les Sports Awards, tout cela ne changeait rien. Les
                      responsables de l’événement avaient imposé un code
                      d’éthique, dans lequel il est précisé que les sportifs et
                      les sportives qui ont été une fois au moins impliqués dans
                      une affaire de dopage n’étaient pas éligibles. Et ils s’y
                      sont tenus. Ils ont traité le cycliste qui avait
                      systématiquement profité du dopage à l’EPO comme la
                      joueuse de tennis qui avait une fois été testée positive à
                      une drogue récréative.
                    </p>
                    <p>
                      Où le grotesque rejoint l’injustice, c’est lorsque l’on
                      constate qu’à la fin de sa suspension pour dopage, Hingis
                      a à nouveau été accueillie les bras ouverts par le circuit
                      professionnel, où elle allait encore connaître de
                      nombreuses années de succès en double, mais aussi par
                      Swiss Olympic, l’organe faîtier du sport suisse de
                      compétition, qui n’a pas vu le moindre problème à la
                      sélectionner pour les Jeux olympiques de 2016.
                    </p>
                    <p>
                      Durant toutes ces années, Hingis a encore été plusieurs
                      fois nominée aux Sports Awards. Mais ce ne fut que lors de
                      l’éloge de l’ensemble de sa carrière qu’elle s’est sentie,
                      enfin, libérée. Simon Graf, l’expert de tennis de la
                      rédaction sportive de Tamedia, a dit tout ce qui devait
                      être dit. Dans un éditorial, il a écrit:
                    </p>
                    <p>
                      «C’est, pour prendre une analogie avec le sport, comme si,
                      au milieu de la partie, les règles du jeu changeaient.» Et
                      un peu plus loin: «Si, avec son contrôle positif, elle
                      était un mauvais exemple, simultanément, elle en était un
                      excellent par sa joie jamais éteinte pour le sport, sa
                      jouerie, sa manière rafraîchissante d’exister dans un
                      monde professionnel, là où tant d’autres sont formatés.
                      Elle a, même en ayant suivi son propre chemin, inspiré
                      beaucoup d’athlètes suisses. Ceux qui réduisent
                      aujourd’hui sa carrière à cette affaire de dopage lui font
                      une grande injustice.»
                    </p>
                  </div>
                </div>
              </Element>

              <Element className='section' name='section-7-4' id='section-7-4'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Chapitre 19</h6>
                    <h5>L’héritage d’une carrière</h5>
                    <p>
                      Lorsque, le 26 octobre 2017, Martina Hingis a annoncé sa
                      retraite définitive, elle l’a fait conformément à son
                      statut: elle était numéro 1 du classement mondial de
                      doubles (elle avait une telle avance sur toutes les autres
                      qu’elle allait encore rester au sommet pendant près d’un
                      semestre, quand bien même elle ne jouait plus!)
                    </p>
                    <SideElement side='right'>
                      <VideoPlayer
                        mp4={require('../../videos/11-doppeltriumph_2017-fr.mp4')}
                        posterImage={require('../../videos/11-doppeltriumph_2017.jpg')}
                        caption="Vingt et un ans après avoir remporté le premier Grand Chelem: triomphe à l'US Open 2017 avec Latisha Chan. Source: US Open"
                      />
                    </SideElement>
                    <p>
                      Cette dernière année sur le circuit en dit plus sur
                      Martina Hingis que ce que l’on imagine dans un premier
                      temps. Particulièrement dans les yeux de Latisha Chan, sa
                      partenaire de double.
                    </p>
                    <p>
                      Née en 1989, Latisha Chan a grandi dans un village de
                      Taïwan. Elle avait 10 ans lorsque sa famille a tout perdu
                      dans un tremblement de terre. Ses parents se sont
                      retrouvés face au néant. De quoi allaient-ils pouvoir
                      vivre?
                    </p>
                    <p>
                      On donna alors à Latisha - un talent du tennis - trois ans
                      pour réussir. Tout ce que les parents gagnaient était
                      investi pour leur enfant.
                    </p>
                    <SideElement side='left'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/7-5-newyork_2007.jpg'
                          : '../../images/7-5-newyork_2007.jpg')}
                      />
                      <figcaption>
                        «Elle riait quand elle jouait une bonne balle et riait
                        quand elle faisait une erreur»: Latisha Chan à propos de
                        sa partenaire de double. Photo: Imago/Xinhua
                      </figcaption>
                    </SideElement>
                    <p>
                      Chan a payé en retour sa famille. Elle est devenue l’une
                      des meilleures joueuses de double de la planète. Mais elle
                      a vécu toutes ces attentes comme un fardeau.
                    </p>
                    <p>
                      «Avec ma propre histoire, en pensant au tremblement de
                      terre et ce qu’il avait causé à ma famille, je croyais que
                      je devais toujours gagner», nous explique-t-elle au
                      téléphone.
                    </p>
                    <p>
                      Ce n’est qu’à 28 ans qu’elle va comprendre que cela
                      pouvait aussi se passer différemment. C’était la saison où
                      elle a joué aux côtés de son idole d’enfance, Martina
                      Hingis.
                    </p>
                    <p>
                      «Début 2017, cela faisait déjà de nombreuses années que
                      j’étais sur le circuit, mais tout continuait de me
                      stresser. La pression, les voyages, les décalages
                      horaires. Martina m’a alors montré que l’on devait
                      profiter de la partie la plus sympa de notre métier: le
                      jeu. Et c’est vrai. Quand je suis à ses côtés sur le
                      court, je sens ses énergies. Je les ressens véritablement.
                      Qu’elle gagne ou qu’elle perde, ce n’était pas vraiment
                      important. Elle riait quand elle jouait bien une balle,
                      elle riait aussi lorsqu’elle commettait une faute. Elle
                      voulait juste passer un bon moment avec sa partenaire.»
                    </p>
                    <p>Latisha Chan réfléchit quelques instants.</p>
                    <p>
                      «Quand je joue avec elle, je ris également plus. C’est
                      cela: Martina m’a appris à rire. À ses côtés, j’étais une
                      autre joueuse. Je tentais des coups que je n’avais jamais
                      osés auparavant. Et le plus beau: elle était là. Je
                      remarquais que j’étais bien dans le coup. Martina a vu
                      quelque chose en moi que je n’avais jamais vu auparavant.»
                    </p>
                    <p>
                      Latisha Chan est l’une des innombrables joueuses de tennis
                      qu’Hingis a inspirées. Lorsque, encore enfant, elle avait
                      reçu de sa part un autographe, elle n’a pu contrôler sa
                      joie. «Plus tard, j’aimerais bien pouvoir grimper dans une
                      machine à remonter le temps pour raconter à la fille de 8
                      ans que j’étais alors que j’ai joué à côté de cette
                      joueuse sur un court.»
                    </p>
                    <p>
                      Et c’est peut-être bien cela qui reste après une longue
                      carrière sportive: savoir que l’on a touché d’autres
                      personnes, comme cette petite fille d’un pays si lointain.
                    </p>
                  </div>
                </div>
              </Element>
            </div>
          </div>
          <Element className='section' name='section-8' id='section-8'>
            <div className='ui vertical segment'>
              <div className='ui text container'>
                <div className='ta text prologue'>
                  <h5>Épilogue</h5>
                  <p>
                    En juillet, à Newport, une petite ville de l’État américain
                    de Rhode Island, des joueurs et des joueuses sont accueillis
                    au Hall of Fame, le temple de la renommée du tennis. C’est
                    une manifestation modeste. Devant quelques invités, sur la
                    place gazonnée, un podium est monté. On fait le panégyrique
                    des élus, il y a quelques applaudissements, les
                    récipiendaires reçoivent une veste bleue nuit. Et c’est
                    terminé.
                  </p>
                  <p>
                    Néanmoins, il s’agit bien de la reconnaissance ultime qu’un
                    professionnel du tennis peut recevoir. Pour les stars, on
                    comprend un peu mieux l’importance du Hall of Fame lorsque
                    l’on prête attention aux discours de remerciements. C’est,
                    très souvent, un aperçu intime de l’âme des plus grands
                    joueurs, des plus grandes joueuses de ces cinquante
                    dernières années.
                  </p>
                  <p>
                    Lors de la célébration de 2009, Monica Seles comptait parmi
                    ceux et celles qui venaient là alors qu’ils étaient au
                    sommet et aussi au fond du trou. En 2004, Steffi Graf est
                    restée longtemps silencieuse, avant d’avouer d’une voix
                    emplie de sanglots: «Le tennis m’a permis de faire cet
                    incroyable voyage et le plus beau, dans ce voyage, c’est
                    qu’il m’a menée à toi.» Puis elle se retourna et désigna son
                    mari, Andre Agassi.
                  </p>
                  <p>
                    Le 13 juillet 2013, Martina Hingis est à son tour entrée au
                    Hall of Fame. Dans son discours, Phil de Picciotto,
                    fondateur de l’agence de marketing sportif Octagon et l’un
                    des premiers promoteurs d’Hingis, rappela combien il
                    l’appréciait, comme joueuse et comme personne. Hingis,
                    assise juste derrière le podium, faisait déjà de gros
                    efforts pour retenir ses larmes.
                  </p>
                  <p>
                    Puis son tour est arrivé. Elle s’est levée, a remercié De
                    Picciotto. Il lui a donné deux bises sur les joues et
                    Hingis, très Suissesse, a attendu la troisième, avant de se
                    rappeler au dernier moment l’usage international et se
                    retirer. Puis elle s’est présentée devant le micro. Elle ne
                    respirait qu’avec difficulté et commença à lire une feuille,
                    d’une voix hésitante.
                  </p>
                  <p>
                    «Je pourrais reprendre les mots que tant d’autres ont
                    utilisés à cette place. Je pourrais dire tout ce que le
                    sport a apporté à ma vie et ce serait l’absolue vérité. Mais
                    je me permets d’élargir quelque peu mon discours, pour que
                    vous compreniez mieux qui je suis et ce que vous représentez
                    pour moi. Je suis née derrière le rideau de fer et ma maman
                    voulait déchirer ce rideau pour moi. C’est pour cela que
                    j’ai commencé à jouer au tennis alors que je n’étais qu’une
                    enfant. En 1980, ma mère n’avait pas beaucoup d’autres
                    possibilités pour m’offrir une vie meilleure, pour me
                    montrer le monde. Elle a choisi le tennis pour pouvoir nous
                    échapper de la prison dans laquelle nous vivions. Merci,
                    maman.»
                  </p>
                  <p>
                    Elle a alors cherché du regard Melanie Molitor et lui a dit
                    directement: «Tu m’as donné la vie, tu m’as offert l’amour.
                    Tu m’as donné le tennis. Tu m’as donné tout ce que tu
                    pouvais.»
                  </p>
                  <div style={{ marginTop: '2em' }}>
                    <VideoPlayer
                      mp4={require('../../videos/12-halloffame_2013-fr.mp4')}
                      posterImage={require('../../videos/12-halloffame_2013.jpg')}
                      caption="Merci maman! Le message de son discours d'intronisation au Hall of Fame. Source: International Tennis Hall of Fame"
                    />
                  </div>
                </div>
              </div>
            </div>
          </Element>
        </div>

        <Footer
          mailTo='patrick.oberli@agencesportcenter.ch'
          locale='fr'
          articleId={ARTICLE_ID}
          title='Comment jugez-vous ce contenu?'
          questions={[
            "L'avez-vous trouvé intéressant",
            'La mise en forme vous plaît-elle?'
          ]}
          credits={[
            [
              'Textes',
              '<a href="mailto:christof.gertsch@dasmagazin.ch">Christof Gertsch</a> & <a href="mailto:mikael.krogerus@dasmagazin.ch">Mikael Krogerus</a>, Das Magazin'
            ],
            ['Adaptation française', 'Jean-Claude Schertenleib'],
            ['Rédaction', 'Bruno Ziauddin, Das Magazin'],
            ['Portraits', 'Cyrill Matter'],
            ['Coiffure et maquillage', 'Helve Leal'],
            ['Styling', 'Martina Russi'],
            ['Tenue', 'Robe en maille de laine mérinos - Jelmoli'],
            ['Rédaction photo', 'Carmen Brunner, Das Magazin'],
            ['Vidéos', 'Adrian Panholzer, Tamedia Video'],
            ['Édition finale', 'Julia Hofstetter, Das Magazin'],
            ['Réalisation digitale', 'Mathias Lutz, Interaktiv-Team']
          ]}
          hidePortfolioTeaser
        />

        <TopMenu
          ref={this.menuRef}
          menuOpen={this.state.menuOpen}
          closeMenu={this.closeMenu}
          openMenu={this.openMenu}
          menuData={parseJsonData(menuData)}
        />
      </div>
    )
  }
}
